<template>
  <div class="animated fadeIn">
      <b-row>
          <b-col sm="12">
              <b-card>
               <template #header>
                <div class="d-flex justify-content-between align-items-center w-100">
                    <span class="font-weight-bold">
                   <i class="cui-graph icons font-2xl mt-4"></i> Parent AWB Tracking
                    </span>

                    <div class="d-flex align-items-center">
                       <b-button
                            variant="primary"
                            size="sm"
                            class="float-right"
                            @click="openBulkTracking">
                            Bulk Shipment Tracking
                        </b-button>  

                        <b-button
                        type="button"
                        size="md"
                        class="ml-4"
                        variant="warning"
                        @click="generateEBNByTaxilla"
                        :disabled="isGeneratingEBN"
                        v-if="showGenerateEBNButton">

                        <b-spinner
                            small
                            class="mr-1"
                            v-if="isGeneratingEBN">
                        </b-spinner>

                        {{ isGeneratingEBN ? 'Generating...' : 'Generate EBN' }}
                    </b-button>     
                    <i
                    v-if="isGeneratingEBN"
                    class="cui-spinner icons font-2xl ml-2 align-middle">
                </i>    

                    </div>
                </div>
                </template>

                 

                  <div class="box">
                      <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                          <b-row>
                              <b-col md="7">
                                  <b-col sm="12" >
                                      <b-form-group>
                                          <b-row>
                                              <b-col sm="4">
                                                  <label for="Parent AWB / Invoice No"><b>Parent AWB / Invoice No</b></label>&nbsp;<span style="color: red;">*</span>
                                              </b-col>
                                              <b-col sm="8">
                                                  <b-form-input class="input" type="text" name="parentawb invoiceno" v-model="customer.parentawb" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.parentawb invoiceno') }" placeholder="Enter Parent AWB / Invoice No">
                                                  </b-form-input>
                                                  <span v-show="errors.has('form-1.parentawb invoiceno')" class="help text-danger">{{ errors.first('form-1.parentawb invoiceno') }}</span>
                                              </b-col>
                                          </b-row>
                                      </b-form-group>
                                  </b-col>
                              </b-col>
                              <b-col md="5" >
                                  <b-button type="submit" size="md" class="mr-4" variant="primary"> Search</b-button>
                                  <b-button type="button" size="md" variant="danger" @click="clear"> Clear</b-button>
                                  <b-button type="button" size="md" class="ml-4" variant="primary" @click="viewPlanDetails()" v-if="showPlanDetailsButton"> View Plan</b-button>
								<b-button type="button" size="md" class="ml-4" variant="success" @click="actionModal()" v-if="actionButton && User_type=='1'"> Action </b-button>
                              </b-col>
                          </b-row>
                      </form>
                  </div>
                
                  <b-col md="12">
                      <b>Shipment Summary</b>
                      <b-table show-empty stacked="md"  :items="parentawbitem"  :fields="Fields"  :current-page="currentPage"  :per-page="perPage"     :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusy" >
                          <div slot="table-busy" class="text-center text-danger my-2">
                              <b-spinner class="align-middle"></b-spinner>
                              <strong>Loading...</strong>
                          </div>
                          <template slot="parentawb" slot-scope="row">
                              <button v-b-tooltip.hover title="View Details" @click="viewDetails(row.item)" style="background-color:white !important;" class="btn btn-link"  >
                              <span style="color:#1b8eb7">{{row.item.parentawb}}</span>
                              </button>
                          </template>
                          
                          <template slot="showtotalmspcount" slot-scope="row">
                              <button v-if="totalmpsCount.count_status != '0'" v-b-tooltip.hover title="View Details" @click="shipmentStatusmodal(totalmpsCount)" style="background-color:white !important;" class="btn btn-link"  >
                              <span style="color:#1b8eb7">{{totalmpsCount.count_status}}</span>
                              </button>
                              <span v-else>
                              {{totalmpsCount.count_status}}
                              </span>
                             
                               <span v-if="row.item.hub_id">
                                <br>
                                   <label style="
                                    background:#e0e0e0;
                                    padding:2px 6px;
                                    border-radius:4px;
                                    font-size:12px;
                                    font-weight:600;
                                    margin-right:4px;
                                    color:#333;
                                    display:inline-block;">
                                    HubID-
                                </label>
                                    {{ row.item.hub_id }}
                                    </span>
                                    
                                <span v-if="row.item.zone_id">
                                     <br/>
                                   <label style="
                                    background:#e0e0e0;
                                    padding:2px 6px;
                                    border-radius:4px;
                                    font-size:12px;
                                    font-weight:600;
                                    margin-right:4px;
                                    color:#333;
                                    display:inline-block;">
                                    zoneID-
                                </label>
                                    {{ row.item.zone_id }}
                                    </span>
                                    <span v-if="row.item.vehicle_id">
                                     <br/>
                                   <label style="
                                    background:#e0e0e0;
                                    padding:2px 6px;
                                    border-radius:4px;
                                    font-size:12px;
                                    font-weight:600;
                                    margin-right:4px;
                                    color:#333;
                                    display:inline-block;">
                                    VID-
                                </label>
                                    <span class="hyperlink" @click="VehicleDetailsModalById(row.item.vehicle_id)">{{ row.item.vehicle_id }}</span>
                                    </span>
                          </template>
                          <template slot="shipmentstatus" slot-scope="row">
                              <div>
                              <p>
                                  {{ row.item.shipmentstatus }} 
                                  
                                  <span v-if="row.item.shipmentstatus !== row.item.deliverystatus">
                                   <br>
                                   <label style="
                                    background:#e0e0e0;
                                    padding:2px 6px;
                                    border-radius:4px;
                                    font-size:12px;
                                    font-weight:600;
                                    margin-right:4px;
                                    color:#333;
                                    display:inline-block;">
                                    DEL-
                                </label>
                                    {{ row.item.deliverystatus }}
                                    </span>
                                     <span v-if="row.item.sysusermasterid">
                                     <br/>
                                   <label style="
                                    background:#e0e0e0;
                                    padding:2px 6px;
                                    border-radius:4px;
                                    font-size:12px;
                                    font-weight:600;
                                    margin-right:4px;
                                    color:#333;
                                    display:inline-block;">
                                    SYSUID-
                                </label>
                                    {{ row.item.sysusermasterid }}
                                    </span>
                                     <span v-if="row.item.warehouseid">
                                     <br/>
                                   <label style="
                                    background:#e0e0e0;
                                    padding:2px 6px;
                                    border-radius:4px;
                                    font-size:12px;
                                    font-weight:600;
                                    margin-right:4px;
                                    color:#333;
                                    display:inline-block;">
                                    WHID-
                                </label>
                                    {{ row.item.warehouseid }}
                                    </span>
                                     <span v-if="row.item.is_handoverload === 'No'  && (!row.item.ebn || row.item.ebn === '')"
       style="background:#ffcccc;
              border-radius:4px;
              font-size:10px;
              font-weight:300;
              color:#333;
              display:inline-block;">
   EBN- Warehouse pending
</span>
                                    </p>
                              </div>
                          </template>

                          <template slot="lastmodifieddate" slot-scope="row">
                              <div>
                                  {{ row.item.lastmodifieddate }}
                              </div>
                          </template>
                          <template slot="delivery_date" slot-scope="row">
                              <div>
                                  {{ row.item.delivery_date }}
                              </div>
                          </template>
                          <template slot="calulatededd" slot-scope="row">
                              <div>
                                  {{ row.item.calulatededd || '' }}
                              </div>
                          </template>

                           <template slot="source" slot-scope="row">
                              <div>
                                  {{ row.item.source || '' }}
                              </div>
                              <div>
                                 <label style="color: blue;">handoverload: {{ row.item.is_handoverload || '' }}</label>
                              </div>
                            <template slot="dispatch_date" slot-scope="row">
                              <div>

                                  {{ row.item.dispatch_date || '' }}
                              </div>
                          </template>
                          </template>
                          
                      </b-table>
                  </b-col>

                  <b-col md="12">
                      <b-table show-empty stacked="md"  :items="parentawbitem"  :fields="mainFields"  :current-page="currentPage"  :per-page="perPage"     :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusy" >
                          <div slot="table-busy" class="text-center text-danger my-2">
                              <b-spinner class="align-middle"></b-spinner>
                              <strong>Loading...</strong>
                          </div>
                          <template slot="parentawb" slot-scope="row">
                              <button v-b-tooltip.hover title="View Details" @click="viewDetails(row.item)" style="background-color:white !important;" class="btn btn-link"  >
                              <span style="color:#1b8eb7">{{row.item.parentawb}}</span>
                              </button>
                          </template>
                          <template slot="invoicevalue" slot-scope="row">
                            <span>&#8377; {{row.item.invoicevalue}}</span>
                            <div class="document-downloads">
                              <a :href="row.item.wms_invoice_url" v-if="row.item.wms_invoice_url" target="_blank" title="Download Forward Invoice"><i class="fa fa-download download-icon"></i></a>
                              <a :href="rtoInvoiceUrl(row.item)" v-if="rtoInvoiceUrl(row.item)" target="_blank" title="Download RTO Invoice / Delivery Challan"><i class="fa fa-download download-icon text-danger"></i></a>
                            </div>
                          </template>
                         <template slot="ebn" slot-scope="row">
                            <a 
                                :href="row.item.ewaybill_file == null 
                                ? 'https://prod-1.e-waybill.in/api/e-waybill/print?ewaybill=' + row.item.ebn
                                : row.item.ewaybill_file" 
                                target="_blank" 
                                class="ebn-link"
                            >
                                <span>{{ row.item.ebn }} </span>
                            </a>

                            <span v-if="row.item.ebn">

                                <i 
                                class="fa fa-download download-icon" 
                                aria-hidden="true" 
                                title="Taxilla Download"
                                @click="downloadDirectTaxillaEwayBill(row.item)"
                                ></i>
                                <a
                                    :href="`https://prod-1.e-waybill.in/api/e-waybill/print?ewaybill=${row.item.ebn}`"
                                    target="_blank"
                                    class="ebn-link"
                                >
                                <i
                                class="fa fa-download download-icon text-danger"
                                aria-hidden="true"
                                title="Direct eway bill download"
                                ></i>
                                </a>
                            </span>

                            <span v-if="row.item.rto_ewaybill_no">
                                <a :href="rtoEwayUrl(row.item)" target="_blank" class="ebn-link" title="RTO Eway Bill">
                                  <span>{{ row.item.rto_ewaybill_no }}</span>
                                  <i class="fa fa-download download-icon text-danger" aria-hidden="true"></i>
                                </a>
                            </span>

                            <div class="ebn-details"  v-if="latestEwayExpiry(row.item)">
                            <p>
                               <br/>
                                <label style="background:#e0e0e0;
                                    padding:1px 4px;
                                    border-radius:4px;
                                    font-size:10px;
                                    font-weight:300;
                                    color:#333;
                                    display:inline-block;">
                                    EXP-
                                </label>
                                {{ latestEwayExpiry(row.item) ? formatDate(latestEwayExpiry(row.item)) : '' }}
                             </p>
                              <span 
                                v-if="row.item.source === 'Warehouse' 
                                        && row.item.is_handoverload === 'No' 
                                        && (!row.item.wms_invoice_url || row.item.wms_invoice_url === '') &&
                                            ![
                                            'BookingPending',
                                            'BookingDone',
                                            'RTO',
                                            'Delivered',
                                            'StockInward',
                                            'RTO-PKUP-CAN',
                                            'Lost',
                                            'partialDLV',
                                            'RTO-eWayBill-EXP'
                                            ].includes(row.item.shipmentstatus)"
                                class="invoice-missing"
                                >
                                Invoice not generated
                                </span>
                            </div>

                            </template>

                          <template slot="awbphysicalweight" slot-scope="row">
                              <span> {{row.item.awbphysicalweight}} {{row.item.awbphysicalweightunit}}</span>
                          </template>
                      </b-table>
                  </b-col>

                  <b-col sm="12" >
                      <b-table show-empty  hover stacked="md" style="table-layout: fixed" :busy="isBusyhistory" :outlined="outlined" :items="formattedItemHistory" :bordered="bordered" :fields="fieldhistory" caption-top>
                          <div slot="table-busy" class="text-center text-danger my-2">
                              <b-spinner class="align-middle">
                              </b-spinner>
                              <strong>Loading...</strong>
                          </div>
                          <!--<template slot="table-caption">
                              <b-row>
                                  <b-col sm="6">
                                      <b>Load tracking history</b>
                                  </b-col>
                                  <b-col  sm="6" class="text-right">
                                      <b-badge v-if="manualUpdate=='Yes'" variant="danger" >Manual Update</b-badge>
                                  </b-col>
                              </b-row>
                          </template>-->
                          <template #table-caption>
                            <b-row class="align-items-center">
                                <b-col sm="6">
                                <b class="h5 m-0">Load Tracking History</b>
                                </b-col>

                                <b-col sm="6" class="text-right">
                                <b-badge 
                                    v-if="manualUpdate === 'Yes'" 
                                    variant="danger"
                                    class="px-3 py-2"
                                >
                                    Manual Update
                                </b-badge>
                                </b-col>
                            </b-row>

                            <div class="mt-2" v-if="actionButton && searchparentawb">
                                <span
                                class="log-link"
                                @click="openMpsLogsModal(searchparentawb)"
                                >
                                MPS Logs
                                </span>

                                <span class="mx-2 text-muted">|</span>

                                <span
                                class="log-link"
                                @click="openActivityModal(searchparentawb)"
                                >
                                Activity Logs
                                </span>
                            </div>
                            </template>
                          <template slot="parentawb" slot-scope="row">
                              <span>{{row.item.parentawb}}</span>
                          </template>
                          <template slot="hub_title" slot-scope="row">
                              <span>{{row.item.hub_title==null?'-':row.item.hub_title}}</span>
                          </template>
                          <template slot="zone_title" slot-scope="row">
                              <span>{{row.item.zone_title==null?'-':row.item.zone_title}}</span>
                          </template>
                         <template slot="manifestedvehicleno" slot-scope="row">
								<span>{{row.item.manifestedvehicleno==null || row.item.manifestedvehicleno=="" ||
									row.item.manifestedvehicleno== undefined ?'-':row.item.manifestedvehicleno}}</span>
									<div v-if="row.item.manifestedvehicleno != null && (row.item.manifestedvehicleno != '' && row.item.manifestedvehicleno != undefined)">
  										<b-badge  style="background-color: green; color:white" v-if=" (row.item.manifested_vh_type === 'inter' || row.item.manifested_vh_type === 'intra') || row.item.manifested_vh_type === 'regular'">Regular</b-badge>
										<b-badge style="background-color: greenyellow; color:white" v-else-if="row.item.manifested_vh_type === 'adhoc'  || row.item.manifested_vh_type === 'Adhoc'">Adhoc</b-badge>
  										<b-badge  style="background-color: greenyellow; color:white" v-else-if="row.item.manifested_vh_type">{{ row.item.manifested_vh_type }}</b-badge>
  										<span v-else></span>
										</div>
							</template>
							<template slot="vehicle_no" slot-scope="row">
								<!-- <b-button  > -->
								<div v-if="row.item.vehicle_no!=null && (row.item.vehicle_no != '' && row.item.vehicle_no != undefined)">
								<span class="hyperlink" @click="VehicleDetailsModal(row.item.vehicle_no)">{{row.item.vehicle_no}}</span></br>
								<b-badge style="background-color: green; color:white" v-if="row.item.main_vh_type === 'Regular' || row.item.main_vh_type === 'inter' || row.item.main_vh_type === 'intra'">Regular</b-badge>
  								<b-badge style="background-color: greenyellow; color:white" v-else-if="row.item.main_vh_type === 'adhoc'">Adhoc</b-badge>
  								<b-badge style="background-color: greenyellow; color:white" v-else>{{ row.item.main_vh_type }}</b-badge>
								<div v-else></div>
									</div>
								<div v-else>-</div>
								
							</template>
							<template slot="createdby" slot-scope="row">
								<div>
									<span v-html="row.item.createdby.replace(/^(adhoc\w*)/i, 'Manual Update').replace('Updated From App', '<b>Updated From App</b>').replace('Manual Update', '<b>Manual Update</b>')"></span>
								</div>
							</template>
                          <template slot="process" slot-scope="row">
                              <span v-if="row.item.process=='HandoverPending'">NDR</span>
                              <span v-else>{{ row.item.process }}</span>
                          </template>
                          <template slot="createddate" slot-scope="row">
                              <div>
                                  {{ row.item.createddate }}
                              </div>
                          </template>
                          <template slot="lastcomments" slot-scope="row">
                                <span>{{ row.item.lastcomments==null || row.item.lastcomments=='' || row.item.lastcomments==undefined ? '-' : row.item.lastcomments}}
                                </span>

                
                                <span v-if="row.item.process=='Damage' && (row.item.lastcomments.includes('Damage marked against') || row.item.lastcomments.includes('Defective marked against'))">
                                    <div v-for="n in extractCodes(row.item.lastcomments)" :key="n">
                                        <b-button variant="light" style="padding: 1px 6px;" :title="n" @click="showDamegeimage(n)">
                                          <i class="fa fa-eye" aria-hidden="true"></i>
                                        </b-button>
                                    </div>
                                </span>
                                <span v-if="row.item.process=='Incident Reported'">
                                    <br>
                                    <b-button variant="light" style="padding: 1px 6px;" title="Incident Image" @click="showIncidentimage(row.item,'img')">
                                        <i class="fa fa-picture-o" aria-hidden="true"></i>
                                    </b-button>
                                    <b-button variant="light" style="padding: 1px 6px;" title="Incident Video" @click="showIncidentimage(row.item,'video')">
                                        <i class="fa fa-video-camera" aria-hidden="true"></i>
                                    </b-button>
                                </span>
                          </template>
                      </b-table>
                  </b-col>

                  <b-modal  modal-class="full-modal" title="View Awb Details" v-model="awbdetailsmodal" @ok="awbdetailsmodal = false" hide-footer>
                      <template slot="default" slot-scope="{ hide }">
                          <b-row class="col-md-12" >
                              <div class="col-md-3">
                                  <span><b>Parent Awb :</b></span>&nbsp;
                                  <span>{{detailsitem.parentawb}}</span>
                              </div>
                              <div class="col-md-3">
                                  <span><b>Booking Mode :</b></span>&nbsp;
                                  <span>{{detailsitem.bookingmode}}</span>
                              </div>
                              <div class="col-md-3">
                                  <span><b>Delivery Status :</b></span>&nbsp;
                                  <span>{{detailsitem.deliverystatus}}</span>
                              </div>
                              <div class="col-md-3">
                                  <span><b>Shipment Status :</b></span>&nbsp;
                                  <span>{{detailsitem.shipmentstatus}}</span>
                              </div>
                          </b-row>
                          <br>
                          <b-row class="col-md-12" >
                              <div class="col-md-3">
                                  <span><b>Load ID :</b></span>&nbsp;
                                  <span>{{detailsitem.invoiceno}}</span>
                              </div>
                              <div class="col-md-3">
                                  <span><b>Invoice Date :</b></span>&nbsp;
                                  <span>{{detailsitem.invoicedate }} </span>
                              </div>
                              <div class="col-md-3">
                                  <span><b>Invoice Value :</b></span>&nbsp;
                                  <span>{{detailsitem.invoicevalue}}</span>
                              </div>
                              <div class="col-md-3">
                                  <span><b>MPS Count:</b></span>&nbsp;
                                  <span>{{detailsitem.mpscount}}</span>
                              </div>
                          </b-row>
                          <br>
                          <b-row class="col-md-12" >
                              <div class="col-md-3">
                                  <span><b>Source Company :</b></span>&nbsp;
                                  <span>{{detailsitem.sourcecompanyname}}</span>
                              </div>
                              <div class="col-md-3">
                                  <span><b> Source Mailid :</b></span>&nbsp;
                                  <span>{{detailsitem.sourceemailid}} </span>
                              </div>
                              <div class="col-md-3">
                                  <span><b>Source Mobile No :</b></span>&nbsp;
                                  <span>{{detailsitem.sourcemobileno}}</span>
                              </div>
                              <div class="col-md-3">
                                  <span><b>Source Type :</b></span>&nbsp;
                                  <span>{{detailsitem.sourcetype}}</span>
                              </div>
                          </b-row>
                          <br>
                          <b-row class="col-md-12" >
                              <div class="col-md-3">
                                  <span><b> Source Address :</b></span>&nbsp;
                                  <span>{{detailsitem.sourceaddress}} </span>
                              </div>
                              <div class="col-md-3">
                                  <span><b>Source City :</b></span>&nbsp;
                                  <span style="color: #28a745; font-weight: 600;">{{detailsitem.sourcecity}}</span>
                              </div>
                              <div class="col-md-3">
                                  <span><b>Source State :</b></span>&nbsp;
                                  <span>{{detailsitem.sourcestate}}</span>
                              </div>
                              <div class="col-md-3">
                                  <span><b>Source Pincode :</b></span>&nbsp;
                                  <span>{{detailsitem.sourcepincode}}</span>
                              </div>
                          </b-row>
                          <br>
                          <b-row class="col-md-12" >
                              <div class="col-md-3">
                                  <span><b>Destination Company :</b></span>&nbsp;
                                  <span>{{detailsitem.destinationcompanyname}}</span>
                              </div>
                              <div class="col-md-3">
                                  <span><b>User ID :</b></span>&nbsp;
                                  <span style="color: #28a745; font-weight: 600;">{{detailsitem.userid}}</span>
                              </div>
                              <div class="col-md-3">
                                  <span><b>WH Id :</b></span>&nbsp;
                                  <span style="color: #28a745; font-weight: 600;">{{detailsitem.warehouseid}} </span>
                              </div>
                              <div class="col-md-3">
                                  <span><b>Destination Mobile No :</b></span>&nbsp;
                                  <span>{{detailsitem.destinationmobileno}}</span>
                              </div>
                          </b-row>
                          <br>
                          <b-row class="col-md-12" >
                              <div class="col-md-3">
                                  <span><b>Destination Poc Name :</b></span>&nbsp;
                                  <span>{{detailsitem.destinationspocpersonname}}</span>
                              </div>
                              <div class="col-md-3">
                                  <span><b> Destination Address :</b></span>&nbsp;
                                  <span>{{detailsitem.destinationaddress}} </span>
                              </div>
                              <div class="col-md-3">
                                  <span><b>Destination City :</b></span>&nbsp;
                                  <span style="color: #28a745; font-weight: 600;">{{detailsitem.destinationcity}}</span>
                              </div>
                              <div class="col-md-3">
                                  <span><b>Destination State :</b></span>&nbsp;
                                  <span>{{detailsitem.destinationstate}}</span>
                              </div>
                          </b-row>
                          <b-row class="col-md-12" >
                              <div class="col-md-3">
                                  <span><b>Destination Pincode :</b></span>&nbsp;
                                  <span>{{detailsitem.destinationpincode}}</span>
                              </div>
                              <div class="col-md-3">
                                  <span><b>Load POtype  :</b></span>&nbsp;
                                  <span style="color: #28a745; font-weight: 600;">{{detailsitem.loadpotype}}</span>
                              </div>
                               <div class="col-md-3">
                                  <span><b>Mail Id :</b></span>&nbsp;
                                  <span>{{detailsitem.destinationemailid}} </span>
                              </div>
                              <div class="col-md-12 pull-right">
                                  <div slot="footer" class="text-right">
                                      <b-button  size="sm" variant="danger" @click="detailsCancel()">Close</b-button>
                                  </div>
                              </div>
                           
                          </b-row>
                      </template>
                      <template slot="modal-footer" slot-scope="{ cancel }">
                          <b-button size="sm" variant="danger" @click="statusmodalCancel()" style="display:none">
                              Cancel
                          </b-button>
                      </template>
                  </b-modal>

                  <b-modal size="xl" title="Count Details" v-model="statusModal" @ok="statusModal = false" hide-footer>
                      <template>
                          <b-row>
                              <b-col sm="12" class="text-right">
                                  <b-button v-if="canClearAllInwardScan()" size="sm" variant="success" class="mr-2" @click="clearAllInwardScan">
                                      All Clear Scan
                                  </b-button>
                                  <p> <b>Total Records :<span style="color:red;"> {{mpstotalRows}}</span></b> </p>
                              </b-col>
                              <div style="float: left;">
                                  <span class="badge ml-2" 
                                      style="background-color:rgb(192, 57, 43); color: white;font-size: 13px; padding: 3px;">DB</span> Damage Box&nbsp;&nbsp;
                                  <span class="badge ml-2" 
                                      style="background-color:rgb(23, 130, 109); color: white;font-size: 11px; padding: 3px;">SB</span> Shortage Box&nbsp;&nbsp;
                              </div>
                              <b-col sm="12">
                                  <b-table show-empty stacked="md"  :items="mpsitems"  :fields="mpsfields"  :current-page="mpscurrentPage"  :per-page="mpsperPage"     :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="logisBusy" >
                                      <div slot="table-busy" class="text-center text-danger my-2">
                                          <b-spinner class="align-middle"></b-spinner>
                                          <strong>Loading...</strong>
                                      </div>
                                      <template slot="shippingid" slot-scope="row">
                                          <span>{{row.item.shippingid}}</span>
                                          <br>
                                          <span v-if="row.item.is_defective=='YES'" class="badge " style="background-color:#c0392b;color:white;font-size: 9px;padding: 3px; cursor: pointer;"  v-b-modal.defective_image_modal @click="Viewimagedetails(row.item)">DB</span>
                                          &nbsp;
                                          <span v-if="row.item.is_shortage=='Yes'" class="badge " style="background-color:rgb(23, 130, 109);color:white;font-size: 9px;padding: 3px; cursor: pointer;">SB</span>
                                      </template>
                                      <template slot="mpsvalue" slot-scope="row">
                                          <span>&#8377;{{row.item.mpsvalue}}</span>
                                      </template>
                                      <template slot="physicalweight" slot-scope="row">
                                          <span> {{row.item.physicalweight}} {{row.item.physicalweightunit}}</span>
                                      </template>
                                      <template slot="LBH" slot-scope="row">
                                          <span> {{row.item.breadth}}*{{row.item.length}}*{{row.item.height}}</span>
                                      </template>
                                      <template slot="shipmentstatus" slot-scope="row">
                                      <span> {{row.item.shipmentstatus}}</span>
                                     
                                      <span v-if="row.item.is_normalbox_scanned!== 'No'" class="hub-id-text ml-2">
                                       <br>
                                            HScan-{{ row.item.is_normalbox_scanned }}
                                        </span>
                                      </template>
                                       <template slot="hub_title" slot-scope="row">
                                          <span> {{row.item.hub_title}}
                                              <span v-if="row.item.hub_id"  class="hub-id-text"><br>HubID-{{ row.item.hub_id }}</span>
                                          </span>
                                      </template>
                                        <template slot="zone_title" slot-scope="row">
                                          <span> {{row.item.zone_title}}
                                              <span v-if="row.item.zone_id" class="hub-id-text"><br>ZoneID-{{ row.item.zone_id }}</span>
                                          </span>
                                       
                                      </template>
                                      <template slot="lastmodifiedby" slot-scope="row">
                                        <div>
                                       {{ row.item.lastmodifiedby }}
                                        </div>
                                           <a v-if="canClearInwardScan(row.item)" href="#" class="clear-scan-link" @click.prevent="clearInwardScan(row.item)">Clear Scan</a>
                                           <div v-if="row.item.quantity && row.item.quantity !== null && row.item.quantity !== undefined">
                                              Pro Qnt: {{ row.item.quantity ? row.item.quantity : '-' }} 
                                           </div>
                                          
                                             <div class="hub-id-text" v-if="row.item.sysusermasterid && row.item.sysusermasterid !== null && row.item.sysusermasterid !== undefined">
                                                   User PDA: {{ row.item.sysusermasterid ? row.item.sysusermasterid : '-' }} <br>
                                               </div>
                                               
                                          
                                      </template>
                                      <template slot="lastmodifieddate" slot-scope="row">
                                          <div>
                                              {{ row.item.lastmodifieddate }}
                                          </div>
                                      </template>
                                  </b-table>
                              </b-col>
                          </b-row>

                          <b-row>
                              <b-col md="6" class="my-1" v-if="mpstotalRows>10">
                                  <b-pagination
                                      v-model="mpscurrentPage"
                                      :total-rows="mpstotalRows"
                                      :per-page="mpsperPage"
                                      class="my-0"
                                      ></b-pagination>
                              </b-col>
                          </b-row>

                          <div class="col-md-12 pull-right">
                              <div slot="footer" class="text-right">
                                  <b-button  size="sm" variant="danger" @click="statusmodalCancel()">Close</b-button>
                              </div>
                          </div>
                      </template>
                      <template slot="modal-footer" slot-scope="{ cancel }">
                          <b-button size="sm" variant="danger" @click="statusmodalCancel()" style="display:none">
                              Cancel
                          </b-button>
                      </template>
                  </b-modal>

                  <b-modal size="md" id="defective_image_modal" title="Defective Image" hide-footer>
                      <div v-if="selected_user_details.defective_imageurl==null" class="text-center">
                          No Record Found
                      </div>
                      <div v-else class="text-center">
                          <img :src="selected_user_details.defective_imageurl" width="100%" height="100%" />
                      </div>
                  </b-modal>

                  <b-modal size="lg" v-model="damageimg" :title="`Damaged MPS No.` + ' - ' + damageMPSno" hide-footer>
                    <div id="listloader" v-if="loader">
                        <div class="listloader"></div>
                    </div>
                    <div v-if="damageitem.length>0" class="text-center mb-3">
                        <div v-for="i in damageitem">
                            <span v-if="i.defective_imageurl">
                                 <img :src="i.defective_imageurl" alt="Damage Image" style="width: 100%;">
                            </span>
                            <span v-else>
                                 Damage Image Not Found
                            </span>
                         </div>
                    </div>
                    <div v-else class="text-center mb-3">
                        Damage Image Not Found
                    </div>
                  </b-modal>

                  <b-modal size="lg" v-model="incidentimage" :title="type=='img'?'Incident Image':'Incident Video'" hide-footer>
                    <div id="listloader" v-if="loader">
                        <div class="listloader"></div>
                    </div>
                    <b-row style="font-family: ui-monospace;">
                        <b-col sm="5">
                           <h5> Vehicle No. - {{incidentitem.vehicle_no}}</h5>
                        </b-col>
                        <b-col sm="7">
                           <h5> Incident Name - {{incidentitem.incident_name}}</h5>
                        </b-col>
                    </b-row>
                    <hr>
                    <br><br>
                    <b-card style="background-color: #eee;border: 1px solid #00000087;">
                        <div class="text-center mb-3" v-if="type=='img'">
                             <img :src="incidentitem.report_image" alt="Incident image" style="width: 100%;">
                        </div>
                        <div class="text-center mb-3" v-if="type=='video'">
                            <b-embed type="video" :src="incidentitem.report_video" controls></b-embed>
                        </div>
                    </b-card>
                  </b-modal>

                <b-modal title="Vehicle Details" v-model="openVehicleDetails" size="xl" hide-footer >
                    <b-form v-if=" vehicleObj.vehicle_type === 'inter' || vehicleObj.vehicle_type === 'intra'">
                        <br />
                        <b-row v-if="(vehicleObj.vehicle_type === 'Adhoc' || vehicleObj.vehicle_type === 'adhoc'  ) && ( vehicleObj.vehicle_type != 'inter' || vehicleObj.vehicle_type != 'intra')">
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="4" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>Hub Name</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                        <b-form-input type="text" name="hub name" v-model="vehicleObj.hub_title" placeholder="-" disabled ></b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row v-if="vehicleObj.vehicle_type != 'adhoc' && (vehicleObj.vehicle_type === 'intra' || vehicleObj.vehicle_type === 'inter')" >
                            <b-row v-if="vehicleObj.vehicle_type != 'adhoc'" >
                                <b-col sm="4">
                                <b-row>
                                    <b-col sm="4" class="pr-0">
                                        <div class="d-flex">  
                                            <label><b>Hub Name</b></label>&nbsp;
                                        </div>
                                    </b-col>
                                    <b-col sm="8" class="pl-0">
                                        <b-form-group>
                                            <b-form-input type="text" name="hub name" v-model="vehicleObj.hub_title" placeholder="-" disabled ></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                </b-col>
                                <b-col sm="4">
                                <b-row>
                                    <b-col sm="4" class="pr-0">
                                        <div class="d-flex">  
                                            <label><b>Vehicle Name</b></label>&nbsp;
                                        </div>
                                    </b-col>
                                    <b-col sm="8" class="pl-0">
                                        <b-form-group>
                                            <b-form-input type="text" name="vehicle name" v-model="vehicleObj.vehiclename" placeholder="Enter Vehicle Name" disabled>
                                            </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                </b-col>
                                <b-col sm="4">
                                <b-row>
                                    <b-col sm="4" class="pr-0">
                                        <div class="d-flex">  
                                            <label><b>Vehicle Number</b></label>&nbsp;
                                        </div>
                                    </b-col>
                                    <b-col sm="" class="pl-0">
                                        <b-form-group>
                                            <b-form-input class="input" type="text" v-model="vehicleObj.vehiclenotext" name="vehicleno" disabled placeholder="-">
                                            </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                </b-col>
                                <b-col sm="4">
                                <b-row>
                                    <b-col sm="4" class="pr-0">
                                        <div class="d-flex">  
                                            <label><b>Registration No</b></label>&nbsp;
                                        </div>
                                    </b-col>
                                    <b-col sm="8" class="pl-0">
                                        <b-form-group>
                                            <b-form-input type="text" name="registration_no" v-model="vehicleObj.registration_notext"  placeholder="-" disabled>
                                            </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                </b-col>
                                <b-col sm="4">
                                <b-row>
                                    <b-col sm="4" class="pr-0">
                                        <div class="d-flex">  
                                            <label><b>Movement Type</b></label>&nbsp;
                                        </div>
                                    </b-col>
                                    <b-col sm="8" class="pl-0">
                                        <b-form-group>
                                            <b-form-input class="input" type="text" v-model="vehicleObj.movement_typetext" name="momenttype" disabled placeholder="-" >
                                            </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                </b-col>
                                <b-col sm="4">
                                <b-row>
                                    <b-col sm="4" class="pr-0">
                                        <div class="d-flex">  
                                            <label><b>Vehicle Type</b></label>&nbsp;
                                        </div>
                                    </b-col>
                                    <b-col sm="8" class="pl-0">
                                        <b-form-group>
                                            <b-form-input class="input" type="text" v-model="vehicleObj.vehicle_type" name="momenttype" disabled placeholder="-" >
                                            </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                </b-col>
                                <b-col sm="4">
                                <b-row>
                                    <b-col sm="4" class="pr-0">
                                        <div class="d-flex">  
                                            <label><b>Vol Weight</b></label>&nbsp;
                                        </div>
                                    </b-col>
                                    <b-col sm="8" class="pl-0">
                                        <b-form-group>
                                            <b-form-input class="input" type="text" v-model="vehicleObj.vehicleweightcarryingtext" name="vehicleweightcarrying" disabled placeholder="-">
                                            </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                </b-col>
                                <b-col sm="4">
                                <b-row>
                                    <b-col sm="4" class="pr-0">
                                        <div class="d-flex">  
                                            <label><b>Phy Weight</b></label>&nbsp;
                                        </div>
                                    </b-col>
                                    <b-col sm="8" class="pl-0">
                                        <b-form-group>
                                            <b-form-input class="input" type="text" v-model="vehicleObj.vehiclephysicalweighttext" disabled name="vehiclephysicalweight" placeholder="-">
                                            </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                </b-col>
                                <b-col sm="4">
                                <b-row>
                                    <b-col sm="4" class="pr-0">
                                        <div class="d-flex">  
                                            <label><b>Dimensions Weight</b></label>&nbsp;
                                        </div>
                                    </b-col>
                                    <b-col sm="8" class="pl-0">
                                        <b-form-group>
                                            <b-form-input class="input" type="text" v-model="vehicleObj.vehicledimensionsweighttext" name="vehicledimensionsweight" disabled placeholder="-">
                                            </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                </b-col>
                                <b-col sm="4">
                                <b-row>
                                    <b-col sm="4" class="pr-0">
                                        <div class="d-flex">  
                                            <label><b>Fuel Type</b></label>&nbsp;
                                        </div>
                                    </b-col>
                                    <b-col sm="8" class="pl-0">
                                        <b-form-group>
                                            <b-form-input class="input" type="text" v-model="vehicleObj.vehicle_fuel_typetext" name="fueltype" disabled placeholder="-">
                                            </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                </b-col>
                                <b-col sm="4">
                                <b-row>
                                    <b-col sm="4" class="pr-0">
                                        <div class="d-flex">  
                                            <label><b>PUC</b></label>&nbsp;
                                        </div>
                                    </b-col>
                                    <b-col sm="8" class="pl-0">
                                        <b-form-group>
                                            <div class="d-flex align-items-center">
                                            <b-button variant="primary" class="ms-3" @click="downloadFile(vehicleObj.puc_urltext)" v-b-tooltip.hover="'Download PUC File'">
                                                <i class="fa fa-download"></i>
                                            </b-button>
                                            </div>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                </b-col>
                                <b-col sm="4">
                                <b-row>
                                    <b-col sm="4" class="pr-0">
                                        <div class="d-flex">  
                                            <label><b>RC</b></label>&nbsp;
                                        </div>
                                    </b-col>
                                    <b-col sm="8" class="pl-0">
                                        <b-form-group>
                                            <div class="d-flex align-items-center">
                                            <b-button variant="primary" class="ms-3" @click="downloadFile(vehicleObj.registration_urltext)" v-b-tooltip.hover="'Download RC File'">
                                                <i class="fa fa-download"></i>
                                            </b-button>
                                            </div>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                </b-col>
                                <b-col sm="4">
                                <b-row>
                                    <b-col sm="4" class="pr-0">
                                        <div class="d-flex">  
                                            <label><b>Permit</b></label>&nbsp;
                                        </div>
                                    </b-col>
                                    <b-col sm="8" class="pl-0">
                                        <b-form-group>
                                            <div class="d-flex align-items-center">
                                            <b-button variant="primary" class="ms-3" @click="downloadFile(vehicleObj.permit_urltext)" v-b-tooltip.hover="'Download Permit File'">
                                                <i class="fa fa-download"></i>
                                            </b-button>
                                            </div>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                </b-col>
                                <b-col sm="4">
                                <b-row>
                                    <b-col sm="4">
                                        <div class="d-flex">  
                                            <label><b>Insurance</b></label>&nbsp;
                                        </div>
                                    </b-col>
                                    <b-col sm="8">
                                        <b-form-group>
                                            <div class="d-flex align-items-center">
                                            <b-button variant="primary" class="ms-3" @click="downloadFile(vehicleObj.insurance_urltext)" v-b-tooltip.hover="'Download insurance File'">
                                                <i class="fa fa-download"></i>
                                            </b-button>
                                            </div>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                </b-col>
                                <b-col sm="4">
                                <b-row>
                                    <b-col sm="4" class="pr-0">
                                        <div class="d-flex">  
                                            <label><b>Labor Charges</b></label>&nbsp;
                                        </div>
                                    </b-col>
                                    <b-col sm="8" class="pl-0">
                                        <b-form-group>
                                            <b-form-input class="input" type="text" v-model="vehicleObj.labour_chargestext" name="labour_charges" disabled placeholder="-">
                                            </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                </b-col>
                                <b-col sm="4">
                                <b-row>
                                    <b-col sm="4" class="pr-0">
                                        <div class="d-flex">  
                                            <label><b>Fixed KM's</b></label>&nbsp;
                                        </div>
                                    </b-col>
                                    <b-col sm="8" class="pl-0">
                                        <b-form-group>
                                            <b-form-input class="input" type="text" v-model="vehicleObj.fixed_kmstext" name="fixed_kms" disabled placeholder="-">
                                            </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                </b-col>
                                <b-col sm="4">
                                <b-row>
                                    <b-col sm="4" class="pr-0">
                                        <div class="d-flex">  
                                            <label><b>Fixed Freight rate</b></label>&nbsp;
                                        </div>
                                    </b-col>
                                    <b-col sm="8" class="pl-0">
                                        <b-form-group>
                                            <b-form-input class="input" type="text" v-model="vehicleObj.fixed_freightrate" name="fixed_freightrate" disabled placeholder="-">
                                            </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                </b-col>
                                <b-col sm="4">
                                <b-row>
                                    <b-col sm="4" class="pr-0">
                                        <div class="d-flex">  
                                            <label><b>Extra KM rate</b></label>&nbsp;
                                        </div>
                                    </b-col>
                                    <b-col sm="8" class="pl-0">
                                        <b-form-group>
                                            <b-form-input class="input" type="text" v-model="vehicleObj.extra_kmratetext" name="extra_kmrate" disabled placeholder="-">
                                            </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                </b-col>
                                <b-col sm="4">
                                <b-row>
                                    <b-col sm="4" class="pr-0">
                                        <div class="d-flex">  
                                            <label><b>Working days</b></label>&nbsp;
                                        </div>
                                    </b-col>
                                    <b-col sm="8" class="pl-0">
                                        <b-form-group>
                                            <b-form-input class="input" type="text" v-model="vehicleObj.workingdaystext" name="workingdays" disabled placeholder="-">
                                            </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                </b-col>
                                <b-col sm="4">
                                <b-row>
                                    <b-col sm="4" class="pr-0">
                                        <div class="d-flex">  
                                            <label><b>Payment Type</b></label>&nbsp;
                                        </div>
                                    </b-col>
                                    <b-col sm="8" class="pl-0">
                                        <b-form-group>
                                            <b-form-input class="input" type="text" v-model="vehicleObj.paymenttypetext" name="paymenttype" disabled placeholder="-">
                                            </b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <!-- </div> -->
                                </b-col>
                                <!-- ***************** -->
                            </b-row>
                        </b-row>
                        <hr />
                        <br />
                        <h6 style="text-align:center"><b>Driver Info</b></h6>
                        <br />
                        <b-row>
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="4" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>First Name</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                        <b-form-input class="input" type="text" id="driverfirstname" name="driverfirstname" disabled v-model="vehicleObj.driverfirstname"  placeholder="-">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="4" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>Last Name</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                        <b-form-input class="input" type="text" id="driverlastname" name="driverlastname" disabled v-model="vehicleObj.driverlastname" placeholder="-">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="4" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>Mobile No</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                        <b-form-input class="input" type="text" maxlength="10" v-model="vehicleObj.drivermobilenumber" disabled name="mobile_no"  placeholder="-">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="4" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>Alt Mobile No</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                        <b-form-input class="input" type="text" maxlength="10" v-model="vehicleObj.driveraltmobilenumber" disabled name="altmobile_no"  placeholder="-">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="4" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>Driving License</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                        <b-form-input class="input" type="text" v-model="vehicleObj.driving_license" name="driving_license" disabled placeholder="-">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="4" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>DL</b></label>
                                    </div>
                                </b-col>
                                <b-col sm="8" class="pl-0">
                                    <!-- <div class="d-flex align-items-center"> -->
                                    <b-form-group class="mb-3">
                                        <div class="d-flex align-items-center">
                                            <b-button variant="primary" class="ms-1" @click="downloadFile(vehicleObj.licence_url)" v-b-tooltip.hover="'Download DL File'">
                                            <i class="fa fa-download"></i>
                                            </b-button>
                                        </div>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <hr />
                        <br />
                        <h6 v-if="vehicleObj.vehicle_type === 'adhoc'" style="text-align:center"><b>Vehicle Info</b></h6>
                        <br/>
                        <b-row  v-if="vehicleObj.vehicle_type === 'adhoc'">
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="4" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>Vehicle Size</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                        <b-form-input class="input" type="text" name="vehiclesize" v-model="vehicleObj.vehicle_size" disabled placeholder="-">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="4" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>Vehicle Dimensions Weight (in feet)</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                        <b-form-input class="input" type="text" name="vehiclesize" v-model="vehicleObj.vehicledimensionsweighttext" disabled placeholder="-">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <h6 v-if="vehicleObj.vehicle_type != 'adhoc' || vehicleObj.vehicle_type != 'Adhoc'" style="text-align:center"><b>Helper Info</b></h6>
                        <br/>
                        <b-row v-if="vehicleObj.vehicle_type != 'adhoc' || vehicleObj.vehicle_type != 'Adhoc'" >
                            <br />
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="4" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>First Name</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                        <b-form-input class="input" type="text" id="helperfirstname" name="helperfirstname" v-model="vehicleObj.helperfirstname" disabled placeholder="-">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="4" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>Last Name</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                        <b-form-input class="input" type="text" id="helperlastname" name="helperlastname" v-model="vehicleObj.helperlastname"  disabled placeholder="-">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="4" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>Mobile No</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                        <b-form-input class="input" type="text" id="addmobilenumber" name="mobilenumber" maxlength="10" v-model="vehicleObj.helpermobilenumber" disabled placeholder="-">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="4" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>Alt Mobile No</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                        <b-form-input class="input" type="text" id="addaltenatemobilenumber" name="helperaltmobilenumber" maxlength="10" v-model="vehicleObj.helperaltmobilenumber"  disabled placeholder="-">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <hr />
                        <br />
                        <h6 style="text-align:center"><b>Transporter Info</b></h6>
                        <br />
                        <b-row v-if="vehicleObj.vehicle_type == 'Adhoc' || vehicleObj.vehicle_type == 'adhoc'"  >
                            <b-col sm="15">
                                <b-form-group label="Company Name" :label-cols="4">
                                <b-form-input class="input" type="text" name="companyname" maxlength="10" v-model="vehicleObj.transporter_company_name"  disabled placeholder="-">
                                </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group label="Transporter Name" :label-cols="4">
                                <b-form-input class="input" type="text" v-model="vehicleObj.transporter_name" name="driver_contracter_name"  placeholder="-" disabled>
                                </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group label="Mobile No" :label-cols="4">
                                <b-form-input class="input" type="text" id="contractormobilenumber" name="mobilenumber" maxlength="10" v-model="vehicleObj.transporter_mobilenumber" placeholder="-" disabled>
                                </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group label="Email ID" :label-cols="4" disabled>
                                <b-form-input class="input" type="text" v-model="vehicleObj.transporter_emailid" name="contracter_emailid" v-validate="'required|email'" placeholder="-" disabled>
                                </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group label="Tin Number / GST Number" :label-cols="4">
                                <b-form-input name="GST Number" type="text" v-model="vehicleObj.transporter_gst_no" disabled placeholder="-">
                                </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row v-if="vehicleObj.vehicle_type != 'adhoc' && (vehicleObj.vehicle_type === 'inter' || vehicleObj.vehicle_type === 'intra')" >
                            <b-col sm="4">
                                <b-form-group :label-cols="4">
                                <template v-slot:label>Type of Vendor </template>
                                <b-form-input class="input" type="text" id="vendor_type" name="vendor_type" maxlength="10" v-model="vehicleObj.t_vendortype"  disabled placeholder="-">
                                </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="15">
                                <b-form-group label="Company Name" :label-cols="4">
                                <b-form-input class="input" type="text" name="companyname" maxlength="10" v-model="vehicleObj.transporter_company_name"  disabled placeholder="-">
                                </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group label="Transporter Name" :label-cols="4">
                                <b-form-input class="input" type="text" v-model="vehicleObj.transporter_name" name="driver_contracter_name" v-validate="'required|alpha_spaces'" placeholder="-" disabled>
                                </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group label="Mobile No" :label-cols="4">
                                <b-form-input class="input" type="text" id="contractormobilenumber" name="mobilenumber" maxlength="10" v-model="vehicleObj.transporter_mobilenumber" placeholder="-" disabled>
                                </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group label="Email ID" :label-cols="4" disabled>
                                <b-form-input class="input" type="text" v-model="vehicleObj.transporter_emailid" name="contracter_emailid" v-validate="'required|email'" placeholder="-" disabled>
                                </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group label="Tin Number / GST Number" :label-cols="4">
                                <b-form-input name="GST Number" type="text" v-model="vehicleObj.transporter_gst_no" disabled placeholder="-">
                                </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group :label-cols="4">
                                <template v-slot:label>
                                    PAN 
                                </template>
                                <b-input-group class="mb-3">
                                    <b-form-input class="input" type="text" id="pan number" name="pan number" v-model="vehicleObj.t_pan" disabled placeholder="-"></b-form-input>
                                </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group :label-cols="4">
                                <template v-slot:label>
                                    Aadhaar
                                </template>
                                <b-input-group class="mb-3">
                                    <b-form-input class="input" type="text" id="adhaar number" name="adhaar number" v-model="vehicleObj.t_aadhar" disabled placeholder="-"></b-form-input>
                                </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group :label-cols="4">
                                <template v-slot:label>
                                    Bank Cancelled Cheque 
                                </template>
                                <div class="d-flex align-items-center">
                                    <!-- Download Button -->
                                    <b-button variant="primary" class="ms-3" @click="downloadFile(vehicleObj.t_bankcancelledcheque)" v-b-tooltip.hover="'Download Bank Cancelled Cheque'">
                                        <i class="fa fa-download"></i>
                                    </b-button>
                                </div>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group :label-cols="4">
                                <template v-slot:label>
                                    GSTIN Certificate
                                </template>
                                <div class="d-flex align-items-center">
                                    <b-button variant="primary" class="ms-3" @click="downloadFile(vehicleObj.t_gstincertificate)" v-b-tooltip.hover="'Download GSTIN Certificate File'">
                                        <i class="fa fa-download"></i>
                                    </b-button>
                                </div>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group :label-cols="4">
                                <template v-slot:label>
                                    Pincode
                                </template>
                                <b-form-input class="input" type="text" id="pincode" name="pincode" v-model="vehicleObj.t_pincode" disabled placeholder="-"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group :label-cols="4">
                                <template v-slot:label>Address</template>
                                <b-input-group class="mb-3">
                                    <b-form-input class="input"  type="text" id="address" name="address" v-model="vehicleObj.t_address" disabled placeholder="-"></b-form-input>
                                </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4" v-if="vehicleObj.t_pincode">
                                <b-form-group :label-cols="4">
                                <template v-slot:label>
                                    City
                                </template>
                                <b-input-group class="mb-3">
                                    <b-form-input class="input" type="text" id="city" name="city" v-model="vehicleObj.t_city"  disabled placeholder="-"></b-form-input>
                                </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4" v-if="vehicleObj.t_pincode">
                                <b-form-group :label-cols="4">
                                <template v-slot:label>
                                    State
                                </template>
                                <b-input-group class="mb-3">
                                    <b-form-input class="input" type="text" id="state" name="state" v-model="vehicleObj.t_state" disabled placeholder="-"></b-form-input>
                                </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group :label-cols="4">
                                <template v-slot:label>
                                    Bank name 
                                </template>
                                <b-input-group class="mb-3">
                                    <b-form-input class="input"  type="text" id="bankname" name="bankname" v-model="vehicleObj.t_branchname" disabled placeholder="-"></b-form-input>
                                </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group :label-cols="4">
                                <template v-slot:label>
                                    Bank Account Name
                                </template>
                                <b-input-group class="mb-3">
                                    <b-form-input class="input" type="text"  id="bankaccountname" name="bankaccountname" v-model="vehicleObj.t_bankaccountname" disabled placeholder="-"></b-form-input>
                                </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group :label-cols="4">
                                <template v-slot:label>
                                    Branch Name
                                </template>
                                <b-input-group class="mb-3">
                                    <b-form-input class="input" type="text"  id="branchname" name="branchname" v-model="vehicleObj.t_branchname" disabled placeholder="-"></b-form-input>
                                </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group :label-cols="4">
                                <template v-slot:label>
                                    Account number
                                </template>
                                <b-input-group class="mb-3">
                                    <b-form-input class="input"  type="text" id="accountnumber" name="accountnumber" v-model="vehicleObj.t_accountnumber" disabled placeholder="-"></b-form-input>
                                </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group :label-cols="4">
                                <template v-slot:label>
                                    IFSC Code
                                </template>
                                <b-input-group class="mb-3">
                                    <b-form-input class="input" type="text" id="ifsccode" name="ifsccode" v-model="vehicleObj.t_ifsccode" disabled placeholder="-"></b-form-input>
                                </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-form v-if=" vehicleObj.vehicle_type == 'adhoc' || vehicleObj.vehicle_type == 'Adhoc'">
                        <b-row>
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="4" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>Hub Name</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                        <b-form-input type="text" name="hub name" v-model="vehicleObj.hub_title" placeholder="-" disabled ></b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <hr />
                        <br />
                        <h6 style="text-align:center"><b>Driver Info</b></h6>
                        <br />
                        <b-row>
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="4" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>First Name</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                        <b-form-input class="input" type="text" id="driverfirstname" name="driverfirstname" disabled v-model="vehicleObj.driverfirstname"  placeholder="-">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="4" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>Last Name</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                        <b-form-input class="input" type="text" id="driverlastname" name="driverlastname" disabled v-model="vehicleObj.driverlastname" placeholder="-">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="4" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>Mobile No</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                        <b-form-input class="input" type="text" maxlength="10" v-model="vehicleObj.drivermobilenumber" disabled name="mobile_no"  placeholder="-">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="5" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>Vehicle Number</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="7" class="pl-0">
                                    <b-form-group>
                                        <b-form-input class="input" type="text" v-model="vehicleObj.vehiclenotext" name="vehicleno" disabled placeholder="-">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="5" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>Fuel Type</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="7" class="pl-0">
                                    <b-form-group>
                                        <b-form-input class="input" type="text" v-model="vehicleObj.vehicle_fuel_typetext" name="fueltype" disabled placeholder="-">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="4" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>Driving License</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                        <b-form-input class="input" type="text" v-model="vehicleObj.driving_license" name="driving_license" disabled placeholder="-">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="5" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>Registration No</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="7" class="pl-0">
                                    <b-form-group>
                                        <b-form-input type="text" name="registration_no" v-model="vehicleObj.registration_notext"  placeholder="-" disabled>
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="4" class="pr-0 d-flex">
                                    <label><b>Status</b></label>&nbsp;
                                </b-col>
                                <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                        <b-form-select
                                            v-model="vehicleObj.isactive"
                                            name="status" disabled>
                                            <option :value="selectstatus">--Select--</option>
                                            <option value="1">Active</option>
                                            <option value="0">InActive</option>
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <hr />
                        <br />
                        <b-row>
                            <b-col sm=12>
                                <h6 style="text-align:center"><b>Vehicle Info</b></h6>
                            </b-col>
                        </b-row>
                        <br/>
                        <br/>
                        <b-row>
                            <b-col sm="4">
                                <b-row>
                                <b-col sm="4" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>Vehicle Size</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                        <b-form-input class="input" type="text" name="vehiclesize" v-model="vehicleObj.vehicle_size" disabled placeholder="-">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                            <b-col sm="5">
                                <b-row>
                                <b-col sm="5" class="pr-0">
                                    <div class="d-flex">  
                                        <label><b>Vehicle Dimensions Weight (in feet)</b></label>&nbsp;
                                    </div>
                                </b-col>
                                <b-col sm="7" class="pl-0">
                                    <b-form-group>
                                        <b-form-input class="input" type="text" name="vehiclesize" v-model="vehicleObj.vehicledimensionsweighttext" disabled placeholder="-">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <hr />
                        <br />
                        <b-row>
                            <b-col sm=12>
                                <h6 style="text-align:center"><b>Transporter Info</b></h6>
                            </b-col>
                        </b-row>
                        <br/>
                        <br/>
                        <b-row>
                            <b-col sm="15">
                                <b-form-group label="Company Name" :label-cols="4">
                                <b-form-input class="input" type="text" name="companyname" maxlength="10" v-model="vehicleObj.transporter_company_name"  disabled placeholder="-">
                                </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group label="Transporter Name" :label-cols="4">
                                <b-form-input class="input" type="text" v-model="vehicleObj.transporter_name" name="driver_contracter_name"  placeholder="-" disabled>
                                </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group label="Mobile No" :label-cols="4">
                                <b-form-input class="input" type="text" id="contractormobilenumber" name="mobilenumber" maxlength="10" v-model="vehicleObj.transporter_mobilenumber" placeholder="-" disabled>
                                </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group label="Email ID" :label-cols="4" disabled>
                                <b-form-input class="input" type="text" v-model="vehicleObj.transporter_emailid" name="contracter_emailid" v-validate="'required|email'" placeholder="-" disabled>
                                </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group label="Tin Number / GST Number" :label-cols="4">
                                <b-form-input name="GST Number" type="text" v-model="vehicleObj.transporter_gst_no" disabled placeholder="-">
                                </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <br />
                    <h6 style="text-align:center"><b>Vehicle Details Change History</b></h6>
                    <div class="col-md-12 px-0 mt-2 ml-0 d-block">
                        <table class="table table-bordered table-hover">
                            <thead>
                                <tr>
                                <th>Vehicle Updated From</th>
                                <th>Vehicle Updated To</th>
                                <th>Vehicle Updated On</th>
                                <th>Vehicle Updated By</th>
                                <th>Comment</th>
                                </tr>
                            </thead>
                            <tbody v-if="vehicle_historylog.length > 0">
                                <tr v-for="(data,key) in vehicle_historylog">
                                <td>{{data.updated_from == 'adhoc' ? data.updated_from : 'Regular' }}</td>
                                <td>{{data.updated_to == 'adhoc' ? data.updated_to : 'Regular'}}</td>
                                <td>{{ data.vehicle_updated_on | ConvertTime12hour() }}</td>
                                <td>{{data.vehicle_updated_by}}</td>
                                <td>{{ data.changecomment }}</td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                <td colspan="12">No Record Found</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <hr/>
                </b-modal>

                <b-modal size="xl" v-model="showPlanDetails" title="View Plan Details" hide-footer>
                    <div id="listloader" v-if="loader">
                        <div class="listloader"></div>
                    </div>
                    <div>
                        <b-card no-body>
                            <div>
                                <b-tabs content-class="palntab" v-if="allPlans.length">
                                <b-tab 
                                    v-for="(plans, index) in allPlans"
                                    :key="index"
                                    :title="generateTabTitle(index + 1, plans.date)">
                                    <!-- Table for displaying plans -->
                                    <b-table show-empty responsive :items="plans.items" :fields="allPlansfields" v-if="plans.items.length" class="pl-3 pr-3">
                                        <template v-slot:cell(loadid)="data">
                                            {{ data.item.loadid }}
                                        </template>
                                        <template v-slot:cell(companyname)="data">
                                            {{ data.item.companyname }}
                                        </template>
                                        <template v-slot:cell(dest_city)="data">
                                            {{ data.item.dest_city }}
                                        </template>
                                        <template slot="whorhub" slot-scope="row">
                                            {{row.item.warehouse_name?row.item.warehouse_name:'-'}} / {{ row.item.hub_name?row.item.hub_name:'-' }}
                                        </template>
                                        <template slot="warehouseorhubname" slot-scope="row">
                                            {{row.item.warehouse_name?row.item.warehouse_name:'-'}} / {{ row.item.hub_zone?row.item.hub_zone:'-' }}
                                        </template>
                                    </b-table>
                                    <!-- Fallback message when there are no plans -->
                                    <p v-else>No plans available for this date.</p>
                                </b-tab>
                                </b-tabs>
                                <p v-else class="text-center mt-3">No plans available for this date.</p>
                            </div>
                        </b-card>
                    </div>
                </b-modal>

                <b-modal size="md" v-model="showActionModal" hide-footer hide-header>
                <b-form @submit.prevent="validateForm1('form-2')" data-vv-scope="form-2">
                    <b-row>
                        <div id="listloader" v-if="loader">
                            <div class="listloader"></div>
                        </div>
                        <b-col md="12">
                            <b-col sm="12">
                            <b-form-group>
                                <b-row>
                                    <b-col md="4">
                                        <label for="Action">Action : <span style="color:red;">*</span></label>
                                    </b-col>
                                    <b-col md="8">
                                        <b-form-select id="Action" name="Action" v-model="form.selectaction" :options="actionOptions" @change="addRemark_mark(form.selectaction)" v-validate="'required' " :class="{ 'input': true, 'is-invalid': errors.has('form-2.Action') }"></b-form-select>
                                        <b-input-group class="mb-3">
                                        <span style="width:240px" v-show="errors.has('form-2.Action')" class="help text-danger">{{
                                        errors.first('form-2.Action') }}</span>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                            </b-col>
                            <b-col sm="12" v-if="remarktextbox">
                            <b-form-group>
                                <b-row>
                                    <b-col md="4">
                                        <label for="Remark">Enter Remark : <span style="color: red;">*</span></label>
                                    </b-col>
                                    <b-col md="8">
                                        <b-form-input type="text" name="Remark" v-validate="'required|alpha_num'" v-model="form.remarktext" :class="{input: true,'is-invalid': errors.has('form-2.Remark'),}" placeholder="Enter your Remark here">
                                        </b-form-input>
                                        <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                        <i class="fa fa-warning" v-show="errors.has('Remark')"></i>
                                        </span>
                                        <span style="width:240px" v-show="errors.has('form-2.Remark')" class="help text-danger">{{ errors.first("form-2.Remark") }}</span>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                            </b-col>
                            <b-col sm="12" v-if="ndrReason">
                            <b-form-group>
                                <b-row>
                                    <b-col md="4">
                                        <label for="NDR reason">NDR Reason : <span style="color:red;">*</span></label>
                                    </b-col>
                                    <b-col md="8">
                                        <!-- {{form.selectReason}} -->
                                        <v-select name="NDR reason" v-model="form.selectReason" placeholder="-- Select Reason --" :options="reasonOptions" v-validate="'required' " :class="{ 'input': true, 'is-invalid': errors.has('form-2.NDR reason') }"></v-select>
                                        <!-- <v-select v-model="form.selectReason" name="NDR reason" :options="reasonOptions" @input="" placeholder="-- Select Reason --" v-validate="'required'" :class="{ input: true, 'is-invalid': errors.has('form-2.NDR reason'),}"></v-select> -->
                                        <b-input-group class="mb-3">
                                        <span style="width:240px" v-show="errors.has('form-2.NDR reason')" class="help text-danger">{{
                                        errors.first('form-2.NDR reason') }}</span>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                            </b-col>
                            <b-col sm="12" v-if="othertextbox">
                            <b-form-group>
                                <b-row>
                                    <b-col md="4">
                                        <label for="Reason">Enter Reason : <span style="color: red;">*</span></label>
                                    </b-col>
                                    <b-col md="8">
                                        <b-form-input type="text" name="Reason" v-validate="'required'" v-model="form1.other" :class="{input: true,'is-invalid': errors.has('form-2.Reason'),}" placeholder="Enter your Reason here">
                                        </b-form-input>
                                        <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                        <i class="fa fa-warning" v-show="errors.has('Reason')"></i>
                                        </span>
                                        <span style="width:240px" v-show="errors.has('form-2.Reason')" class="help text-danger">{{ errors.first("form-2.Reason") }}</span>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                            </b-col>
                            <b-col sm="12" class="text-right">
                            <b-button v-if="form.remarktext" type="submit" size="md" class="mr-4" variant="outline-dark" @click="updateRemark()"> Update Remark </b-button>
                            <!-- {{ form.selectReason }} -->
                            <b-button v-if="form.selectReason" type="submit" size="md" class="mr-4" variant="outline-dark" @click="updatendr()"> Update NDR </b-button>
                            <b-button type="button" size="md" variant="danger" @click="clear1"> Clear</b-button>
                            </b-col>
                        </b-col>
                    </b-row>
                </b-form>
                </b-modal>

                <b-modal size="xl" v-model="mpsdetailsModal" title="Mps Log Details" hide-footer>
                    <div class="mb-2">
                        <strong>Total Log: {{ mpsdetails.length }}</strong>
                    </div>
                    <b-table striped hover :items="mpsDetailsWithSerial" :fields="mpslogFields">
                       <template slot="createddate" slot-scope="row">
                              <div>
                                  {{ creformatDate(row.item.createddate)}}
                              </div>
                          </template>
                    </b-table>
                </b-modal>

                 <b-modal size="xl" v-model="actdetailsModal" title="Activity Log Details" hide-footer>
                    <div class="mb-2">
                        <strong>Total Log: {{ actdetails.length }}</strong>
                    </div>
                    <b-table striped hover :items="actdetails" :fields="actFields">
                       <template slot="createddate" slot-scope="row">
                              <div>
                                  {{ creformatDate(row.item.createddate)}}
                              </div>
                          </template>
                    </b-table>
                </b-modal>

              </b-card>
          </b-col>
      </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
export default {
    data: function () {
        return {
            loader:false,
            isBusy: false,
            is_history_Busy: false,
            customer: {},
            searchparentawb: '',
            outlined: true,
            bordered: true,
            data: [],
            items: [],
            dlvstatus: [],
            servicetype: [],
            iswarrantyshipment: [],
            rpickdoneimg: [],
            img1: [],
            is_mark_ofd: 0,
            imgpath: [],
            rpickdoneimgpath: [],
            urlrpickdoneImg: [],
            urlImg: [],
            rpickdonepath: [],
            customlogdata: [],
            smslogdata: [],
            osremaildata: [],
            searchvaluesarr: [],
            shippingid: '',
            customFields: [
              {key: 'shippingid',label: 'Shipping Id'}, 
              {key: 'drivername',label: 'Driver Name'}, 
              {key: 'vehiclenumber',label: 'Vehicle Number'}, 
              {key: 'shipmentstatus',label: 'Shipment Status'}, 
              {key: 'type',label: 'Type'}, 
              {key: 'created_datetime',label: 'Date'}, 
              {key: 'pushflag',label: 'Status'}
            ],
            logisticlogdata: [],
            parentawbitem: [],
            parentawbitem_length: 0,
            Fields: [
              {key: 'parentawb', label: 'Parent AWB',sortable: true},
              {key: 'invoiceno',label: 'Invoice',sortable: true},
              {key: 'showtotalmspcount',label: 'Total MPS Count',sortable: true},
              {key: 'shipmentstatus', label: 'Current Shipment Status',sortable: true},
              {key: 'lastmodifieddate', label: 'Status Marked Date',sortable: true},
              {key: 'delivery_date',label: 'Actual Delivery Date',sortable: true},
              {key: 'calulatededd',label: 'EDD',sortable: true},
              {key: 'source',label: 'Source',sortable: true},
            ],
            mainFields: [
              {key: 'invoicevalue', label: 'Invoice Value', sortable: true, class: 'invoicevalue'},
                {
                    key: 'ebn',
                    label: 'EBN',
                    sortable: true
                },
                {
                    key: 'awbphysicalweight',
                    label: 'Weight',
                    sortable: true,
                    class: 'physicalweight'
                },
                {
                    key: 'sourcecompanyname',
                    label: 'Origin Name',
                    sortable: true
                },
                {
                    key: 'destinationcompanyname',
                    label: 'Destination Name',
                    sortable: true
                },
                {
                    key: 'destinationaddress',
                    label: 'Destination Address',
                    sortable: true
                },
            ],

            mpsfields: [{
                    key: 'shippingid',
                    label: 'MPS No',
                    sortable: true,
                    sortDirection: 'desc'
                },
                {
                    key: 'mpsvalue',
                    label: 'MPS Value',
                    sortable: true,
                    sortDirection: 'desc'
                },
                {
                    key: 'LBH',
                    label: 'LBH',
                    sortable: true,
                    sortDirection: 'desc'
                },
                {
                    key: 'physicalweight',
                    label: 'Physical Weight',
                    sortable: true,
                    sortDirection: 'desc'
                },
                {
                    key: 'shipmentstatus',
                    label: 'Shipment Status',
                    sortable: true,
                    sortDirection: 'desc'
                },
                {
                    key: 'deliverystatus',
                    label: 'Delivery Status',
                    sortable: true,
                    sortDirection: 'desc'
                },
                {
                    key: 'hub_title',
                    label: 'Hub Name',
                    sortable: true,
                    sortDirection: 'desc'
                },
                {
                    key: 'zone_title',
                    label: 'Zone Name',
                    sortable: true,
                    sortDirection: 'desc'
                },                
                {
                    key: 'lastmodifiedby',
                    label: 'Last Modified By',
                    sortable: true,
                    sortDirection: 'desc'
                },
                {
                    key: 'lastmodifieddate',
                    label: 'Last Modified on',
                    sortable: true,
                    sortDirection: 'desc'
                },
            ],
            mpsitems: [],
            mpstotalRows: 0,
            mpscurrentPage: 1,
            mpsperPage: 10,
            totalCount: {},
            OFDCount: {},
            NDRCount: {},
            DLVCount: {},


            statusdata: [{
                    key: 'shippingid',
                    label: 'Shipping Id'
                },
                {
                    key: 'courierstatus',
                    label: 'Courier Status'
                },
                {
                    key: 'createddate',
                    label: 'Created Date'
                },
                {
                    key: 'pushflag',
                    label: 'Status'
                },
                {
                    key: 'return_response',
                    label: 'Response'
                }
            ],
            fielddata: [{
                    key: 'shippingid',
                    label: 'Shipping Id'
                },
                {
                    key: 'pickuplocationname',
                    label: 'Pickup Location Name'
                },
                {
                    key: 'process',
                    label: 'Process'
                },
                {
                    key: 'comments',
                    label: 'Comments'
                },
                {
                    key: 'createdby',
                    label: 'Created By'
                },
                {
                    key: 'createddate',
                    label: 'Created Date'
                },
                {
                    key: 'latlong',
                    label: 'Lat Long'
                }
            ],
            smsFields: [{
                    key: 'shippingid',
                    label: 'Shipping Id'
                },
                {
                    key: 'mobilenumber',
                    label: 'Mobile Number'
                },
                {
                    key: 'smsapiresponse',
                    label: 'Sms Api Response'
                },
                {
                    key: 'issmssent',
                    label: 'SMS Sending Status'
                },
                {
                    key: 'sms_sent_date',
                    label: 'SMS Sent Date'
                },
                {
                    key: 'action',
                    label: 'Action'
                }
            ],
            osremailfields: [{
                    key: 'shippingid',
                    label: 'Shipping Id'
                },
                {
                    key: 'fcaccountid',
                    label: 'FC ID'
                },
                {
                    key: 'emailapiresponse',
                    label: 'Email Api Response'
                },
                {
                    key: 'emailsendingstatus',
                    label: 'Email Sending Status'
                },
                {
                    key: 'email_sent_date',
                    label: 'Email Sent Date'
                },
                {
                    key: 'action',
                    label: 'Action'
                }
            ],
            response_msg: '',
            babygeardata: [],
            babygearfields: [{
                    key: 'shippingid',
                    label: 'Shipping Id'
                },
                {
                    key: 'created_date',
                    label: 'Created Date'
                },
                {
                    key: 'created_by',
                    label: 'Created By'
                },
                {
                    key: 'return_response',
                    label: 'Response'
                }
            ],
            itemhistory: [],
            fieldhistory: [{
                    key: 'parentawb',
                    label: 'Parent AWB'
                },
                {
                    key: 'process',
                    label: 'Process'
                },
                {
                    key: 'hub_title',
                    label: 'Hub Name'
                },
                {
                    key: 'zone_title',
                    label: 'Zone Name'
                },
                {
                    key: 'manifestedvehicleno',
                    label: 'Manifested Vehicle'
                },
                {
                    key: 'vehicle_no',
                    label: 'Vehicle No.'
                },
                {
                    key: 'createdby',
                    label: 'Created By'
                },
                {
                    key: 'createddate',
                    label: 'Created Date'
                },
                {
                    key: 'lastcomments',
                    label: 'Comments'
                },
            ],
            awbdetailsmodal: false,
            detailsitem: '',
            statusModal: false,
            ConsignmentMasterGetdata: [],
            isConsignmentActivityTrackingGetWeb: 0,
            isConsignmentMasterGetStatus: 0,
            isGetlogisticlogdetails: 0,
            route_id: null,
            selected_user_details: '',
            mpscountitem: [],
            mpscountitem_length: 0,
            OFDmpsCount: {},
            totalmpsCount: {},
            NDRmpsCount: {},
            DLVmpsCount: {},
            manualUpdate: '',
            damageimg:false,
            damageMPSno:'',
            damageitem:[],
            incidentimage:false,
            incidentitem:[],
            type:'',
            imgdata:[],
            logisBusy:false,
            isBusyhistory:false,
            openVehicleDetails: false,
			vehicleObj:{},
			showPlanDetails:false,
            showPlanDetailsButton:false,
            actionButton: false,
			showActionModal: false,
            form:{
                selectaction: null,
                remarktext: '',
                selectReason: null,
                other:''
            },
            reasonOptions: [
                // { text:'-- Select Reason --', value:'null'},
                // { text:'MIS Load wise' , value: 'loadWise'},
                // { text:'MIS HubInOutScan', value: 'HubInOutScan'},
                // { text:'3 Month flash report', value: '3monthFlashReport'},
                // { text:'FTL DeliveredShipments Info Data Report', value: 'deliveredShipmentsReports'}
            ],
            actionOptions: [
                { text:'-- Select Action --', value:'null'},
                { text:'Add Remark' , value: 'addRemark'},
                { text:'Mark NDR', value: 'markNDR'}
            ],
            remarktextbox: false,
			ndrReasonButton: false,
            allPlans: [],
			allPlansfields: 
            [
                {
					key: "planning_origin",
					label: "Planning Origin",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "planning_date",
					label: "Planning Date",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "loadid",
					label: "Load ID",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "whorhub",
					label: "WH/HUB",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "noofboxes",
					label: "No. Of Boxes",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "shippingreferenceno",
					label: "Shipping Ref. No.",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "userid",
					label: "User ID",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "companyname",
					label: "Company Name",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "dest_city",
					label: "Dest_City",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "warehouseorhubname",
					label: "warehousename / Hub zone",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "loadpotype",
					label: "loadpotype",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "shipmentvolumetricweight",
					label: "shipmentvolumetric weight",
					sortable: true,
					sortDirection: "desc",
				}, {
					key: "shippincode",
					label: "shippincode",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "unloading_sequence",
					label: "unloading sequence",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "vehicle_number",
					label: "vehicleno",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "transporter_name",
					label: "transporter name",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "regular_or_adhoc",
					label: "isregularadhoc",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "trip",
					label: "trip",
					sortable: true,
					sortDirection: "desc",
				},
				{
					key: "remark",
					label: "remark",
					sortable: true,
					sortDirection: "desc",
				}
			],
            ndrReason: false,
            othertextbox: false,
            vehicle_historylog:[],
            routeStatus: "",
            routeAction: "",
            User_type:'',
            vehicleObj: {
                vehicle_id: '',
                vehicle_number: '',
                vehicle_size: '',       
                vehicledimensionsweighttext: '',
                transporter_company_name: '',
                transporter_name: '',
                transporter_mobilenumber: '',
                transporter_emailid: '',        
                transporter_gst_no: '',
                isactive: '',
                vehicle_updated_by: '',
                vehicle_updated_on: '',             
                updated_from: '',
                updated_to: '',
                changecomment: '',
                vehicle_size: '',
                vehicle_dimensions_weight: '',
                transporter_company_name: '',
                transporter_name: '',
                transporter_mobilenumber: '',
                transporter_emailid: '',
                transporter_gst_no: '',
                isactive: '',
                vehicle_updated_by: '',
                vehicle_updated_on: '',
                updated_from: '',
                updated_to: '',
                changecomment: ''
            },
            showVehicleDetails: false,      
            showAction: false,
            showActionButton: false,
            form1: {
                selectReason: null,
                other: '',
                parentawb: ''       
            },
            routefunction: '',
            loader: false,
            showActionModal: false,    
            showPlanDetails: false,
            showPlanDetailsButton: false,          
            actionButton: false,
            vehicleDetails: {},
            mpsdetailsModal: false,
            mpsdetails: [],
            mpslogFields: [
            { key: 'srNo', label: 'Sr No' },
            { key: 'shippingid', label: 'Shipping ID' },
            { key: 'shipmentstatus', label: 'Shipment Status' },
            { key: 'hub_id', label: 'Hub ID' },
            { key: 'sysusermasterid', label: 'User ID' },
            { key: 'vehicle_id', label: 'Vehicle ID' },
            { key: 'zone_id', label: 'Zone ID' },
            { key: 'is_defective', label: 'is_defective' },
            { key: 'is_shortage', label: 'is_shortage' },
            { key: 'handover_by', label: 'Handover By' },
            { key: 'createdby', label: 'Created By' },
            { key: 'createddate', label: 'Created Date' },
            { key: 'lastmodifiedby', label: 'comments' },
            ],
            actdetailsModal: false,
            actdetails: [],
            actFields: [
            { key: 'parentawb', label: 'Parent AWB' },
            { key: 'process', label: 'Process' },
            { key: 'comments', label: 'Comments' },
            { key: 'mobilenumber', label: 'Mobile Number' },
            { key: 'vehicle_id', label: 'Vehicle ID' },
            { key: 'hub_id', label: 'Hub ID' },
            { key: 'zone_id', label: 'Zone ID' },           
            { key: 'createdby', label: 'Created By' },
            { key: 'createddate', label: 'Created Date' },
            { key: 'reallocation_reason', label: 'ReallCa Reason' }

            ],
            showGenerateEBNButton: false,
            isGeneratingEBN: false

            
            
        }
    },
    created: function () {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.User_type = userInfo.user_type;
        console.log("User_typeUser_typeUser_typeUser_type", this.User_type);
        this.route_id = this.$route.params.id;
        this.customer.parentawb = this.$route.query.status;
        this.routeAction = this.$route.query.HideAnyAction;
        if (this.routeAction=='Yes') {
            this.routefunction(this.customer.parentawb);
        }
    },

    computed: {
        mpsDetailsWithSerial() {
            const groups = {};
            return this.mpsdetails.map(item => {
            const status = item.shipmentstatus || "UNKNOWN";

            if (!groups[status]) {
                groups[status] = 1;   // first entry = 1
            }

            const srNo = groups[status]++;

            return {
                ...item,
                srNo,
            };
            });
        },
        formattedItemHistory() {
        let incidentReportedCount = 0;

        return this.itemhistory.map((element, index) => {
            if (element.process === 'Incident Reported') {
            element.index = incidentReportedCount++;
            }
            return element;
        });
        }
    },

    methods: {
     openBulkTracking() {
            const routeData = this.$router.resolve({
                path: '/bulkshipmenttracking'
            });
            window.open(routeData.href, '_blank');
        },
        generateEBNByTaxilla() {
                

            if (!this.searchparentawb) {
                this.$fire({
                    text: "Please search a Parent AWB first.",
                    type: "warning",
                    timer: 3000
                });
                return;
            }
            this.isGeneratingEBN = true;

            this.$http.get(
                `${CONSTANTS.MIGRATION_API_URL}/generateEBNByTaxilla`,
                {
                    params: {
                        parentawb: this.searchparentawb
                    }
                }
            ).then((result) => {
                if (result.body.msg === "0"|| result.body.msg === "2") {
                    this.$fire({
                        text: result.body.result,
                        type: "success",
                        timer: 30000
                    });
                    // Optional: Refresh tracking details
                    this.tracking_main(this.searchparentawb);
                } else {
                    this.$fire({
                        text: result.body.result || "Unable to generate EBN.",
                        type: "error",
                        timer: 30000
                    });
                }
            }).catch((err) => {
                this.isBusy = false;
                console.error(err);
                this.$fire({
                    text: "Something went wrong.",
                    type: "error",
                    timer: 30000
                });
            }).finally(() => {
                    this.isGeneratingEBN = false;
            });
        },
        creformatDate(date) {
            if (!date) return "-";
            const d = new Date(date);
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();
            const hrs = String(d.getHours()).padStart(2, '0');
            const mins = String(d.getMinutes()).padStart(2, '0');
            const secs = String(d.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hrs}:${mins}:${secs}`;
        },
        showScanValue(item) {
        const statusList = [
            'INTransit',
            'PickDone',
            'HubInScan'
        ];
        return statusList.includes(item.shipmentstatus);
        },
        formatDate(date) {
        if (!date) return ''
        return date.split(' ')[0]
        },
        isRtoShipment(item) {
            return !!item && (String(item.shipmentstatus || '').toUpperCase().indexOf('RTO') === 0 || !!item.rto_ewaybill_no);
        },
        rtoEwayUrl(item) {
            return item && item.rto_ewaybill_no
                ? `https://prod-1.e-waybill.in/api/e-waybill/print?ewaybill=${item.rto_ewaybill_no}&html-detail=true`
                : '';
        },
        rtoInvoiceUrl(item) {
            if (!item || !this.isRtoShipment(item)) return '';
            return item.rto_invoice_url || item.wms_invoice_url || '';
        },
        latestEwayExpiry(item) {
            if (!item) return '';
            return item.rto_ewaybill_no && item.rto_ewaybill_expirydate
                ? item.rto_ewaybill_expirydate
                : item.ebnexpirydate;
        },
        updateNDRAPI(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const obj = { 
                parentawb : this.customer.parentawb,
                deliverystatuscode : this.form1.selectReason,
                awb_remark : 'testahsmla',
                lastmodifiedby:`${userInfo.sysemailid}`
            }
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/markOFDToNDRByCMS`, obj).then(result => {
                console.log("result",result)
                return false
            })
        },
        redirectToDamageShortagePage(value){
            if(!value || !value.length){
                this.$fire({
                    text: "No data available to redirect",
                    type: "warning",
                    timer: 30000
                });
                return;
            }
            const url = this.$router.resolve({
            path: "/damage_shortage",
            query: { awbDetails:  JSON.stringify(value),HideAnyAction:'Yes' }
            }).href;
            window.open(url, "_blank"); // Opens in a new tab
        },
        VehicleListingLog(value){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            let obj = { vehicleid:value }
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllVehiclelogMaster`,obj)
            .then(result => {
                if(result.body.returnmsg === "Successful"){
                    this.vehicle_historylog = result.body.returnvalue;
                    console.log('vehicle_historylog=========>',this.vehicle_historylog)
                }else{
                    this.vehicle_historylog=[];
                }
            }).catch(ex => {
                console.log('error', ex)
            })
        },
        validateForm1(scope){
            //console.log("pppppppppppp",scope);
            // this.form = {}
            // // this.errors.clear('form-2')
            this.$validator.validateAll(scope).then((Result) => {
                if(Result){
                    
                }
            })
        },
        validateForm(scope) {
            this.parentawbitem = [];
            this.parentawbitem_length = 0;
            this.OFDCount = {};
            this.totalCount = {};
            this.NDRCount = {};
            this.DLVCount = {};
            this.itemhistory = [];
            this.searchvaluesarr = []
            this.ConsignmentMasterGetdata = []
            this.customlogdata = []
            this.smslogdata = []
            this.osremaildata = []
            this.logisticlogdata = []
            this.data = []
            this.dlvstatus = []
            this.is_mark_ofd = 0;
            this.babygeardata = [];
            this.response_msg = '';
            this.mpscountitem = [];
            this.mpscountitem_length = 0;
            this.OFDmpsCount = {};
            this.totalmpsCount = {};
            this.NDRmpsCount = {};
            this.DLVmpsCount = {};
            this.errors.clear('form-1')
            this.$validator.validateAll(scope).then((result) => {
                if (result) {

                    var parentawb = this.customer.parentawb
                    var searchvalues = parentawb.split(',')
                    for (var i = 0; i < searchvalues.length; i++) {
                        this.searchvaluesarr.push(`${searchvalues[i]}`)
                    }
                    this.babygeardata = [];
                    this.parentawb = this.customer.parentawb;

                    this.tracking_main(this.parentawb);
                    this.trackinghistory(this.parentawb);
                    this.tracking_mpscount(this.parentawb);

                }
            })
        },
        updatendr(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            this.loader = true;
            const Obj = {                
                parentawb : this.customer.parentawb,
                deliverystatusname : this.form.selectReason.label,
                deliverystatuscode : this.form.selectReason.key,
                lastmodifiedby : userInfo.sysemailid
            }
            // console.log("ygdjhbcdhcbsdhcdugduygh",Obj)
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/markOFDToNDRByCMS`, Obj).then(result => {
                this.loader = false;
                if (result.body.returnmsg === 'Successful') {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "success",
                        timer: 30000
                    });
                    this.showActionModal = false;
                    this.tracking_main(this.customer.parentawb);
                    this.trackinghistory(this.customer.parentawb);
                    this.tracking_mpscount(this.customer.parentawb);
                }else{
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000
                        });
                }


            }).catch(ex =>{ })
        },
        addRemark_mark(select){
            // console.log("esrdfghjszxdcfvgbnrdfgh",select);
            this.form.other = '';
            this.form.remarktext = '';
            this.form.selectReason = null;
            if( select == 'addRemark'){
                this.remarktextbox = true;
            }else{
                this.remarktextbox = false;
            }
            if( select == 'markNDR' ){
                this.ndrReason = true;
            }
            else{
                this.ndrReason = false;
                this.ndrReasonButton = false;
                this.othertextbox = false;
            }
        },
        getNdrReasons(){
            this.loader = true;
            console.log("in ndrgetreasons");
            const obj = { 
                isactive : "1",
                service_type : "Delivery",
                language : 'en'
            }
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getdeliverystatusmasterlist`, obj).then(result => {
                this.loader = false;
                if(result.body.returnmsg == 'Successful'){
                    this.reasonOptions = result.body.returnvalue.map(item => ({
                        key: item.deliverystatuscode,
                        label: item.deliverystatusname,
                    }));
                   
                }

            }).catch(ex => { })
        },
        routefunction(awbno){
            console.log("awbno",awbno)
            if (awbno.length > 0 && awbno){
                this.tracking_main(awbno);
                this.trackinghistory(awbno);
                this.tracking_mpscount(awbno);
            }
        },
        shipmentStatusmodal: function (status) {
            this.mpscurrentPage = 1;
            this.statusModal = true;
            this.logisBusy = true;
            let userData = localStorage.getItem('userData');
            let userInfo = JSON.parse(userData);


            let obj = {
                parentawb: this.parentawb,
                count_status: status.count_label,
            }
            // return false
            this.$http
                .post(
                    `${CONSTANTS.MISREPORT_API_URL}/getMPSListFromLoad`, obj)
                .then(result => {
                    console.log(result.body);
                    this.logisBusy = false;
                    if (result.body.returnmsg === "successful") {

                        this.mpsitems = result.body.returnvalue;
                        this.mpstotalRows = result.body.returnvalue.length;

                    } else {
                        this.mpsitems = [];
                        this.mpstotalRows = 0
                    }
                }).catch(ex => {
                    console.log('error', ex)
                })

        },

        canClearInwardScan: function (item) {
            return String(item.is_normalbox_scanned || '').toLowerCase() === 'yes'
        },

        canClearAllInwardScan: function () {
            return this.mpsitems.some(item => this.canClearInwardScan(item));
        },


        clearAllInwardScan: function () {
            const eligible = this.mpsitems.filter(item => this.canClearInwardScan(item));
            if (!eligible.length) return;
            this.$bvModal.msgBoxConfirm(`Clear inward scan for ${eligible.length} MPS boxes?`, {
                title: 'Clear all inward scans', okTitle: 'Yes, clear all', cancelTitle: 'No',
                okVariant: 'success', cancelVariant: 'secondary', centered: true
            }).then(confirmed => {
                if (!confirmed) return null;
                const userData = JSON.parse(localStorage.getItem('userData') || '{}');
                this.logisBusy = true;
                return this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/clearMPSInwardScanBulk`, {
                    parentawb: this.parentawb || this.searchparentawb,
                    createdby: userData.sysemailid || userData.userfirstname || ''
                });
            }).then(result => {
                if (!result) return;
                if (result.body && result.body.returnmsg === 'successful') {
                    this.$bvToast.toast(`${result.body.returnvalue.cleared_count} inward scans cleared successfully`, { variant: 'success', solid: true });
                    this.shipmentStatusmodal(this.totalmpsCount);
                    this.trackinghistory(this.searchparentawb || this.parentawb);
                } else {
                    this.$bvToast.toast((result.body && result.body.returnvalue) || 'Unable to clear inward scans', { variant: 'danger', solid: true });
                }
            }).catch(() => this.$bvToast.toast('Unable to clear inward scans', { variant: 'danger', solid: true }))
              .finally(() => { this.logisBusy = false; });
        },

        clearInwardScan: function (item) {
            const userName = item.lastmodifiedby || 'this user';
            this.$bvModal.msgBoxConfirm(`Do you want to clear the inward scan by "${userName}"?`, {
                title: 'Clear inward scan', okTitle: 'Yes, clear scan', cancelTitle: 'No',
                okVariant: 'success', cancelVariant: 'secondary', centered: true
            }).then(confirmed => {
                if (!confirmed) return;
                const userData = JSON.parse(localStorage.getItem('userData') || '{}');
                return this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/clearMPSInwardScan`, {
                    mpsno: item.shippingid,
                    createdby: userData.sysemailid || userData.userfirstname || ''
                });
            }).then(result => {
                if (result && result.body && result.body.returnmsg === 'successful') {
                    this.$bvToast.toast('Inward scan cleared successfully', { variant: 'success', solid: true });
                    this.shipmentStatusmodal(this.totalmpsCount);
                    this.trackinghistory(this.searchparentawb || this.parentawb);
                } else if (result) {
                    this.$bvToast.toast(result.body.returnvalue || 'Unable to clear inward scan', { variant: 'danger', solid: true });
                }
            }).catch(() => this.$bvToast.toast('Unable to clear inward scan', { variant: 'danger', solid: true }));
        },

        statusmodalCancel: function () {
            this.statusModal = false;
        },

        tracking_main: function (value) {
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            this.isBusy = true;
            this.showGenerateEBNButton = false;

            const Getobj = {
                parentawb: value,
                is_asn: this.route_id == 'normal' ? 'NO' : 'YES',
            }
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getParentAwbDetails`, Getobj)
                .then((result) => {
                    this.isBusy = false;
                    if (result.body.returnmsg === 'successful') {
                        this.showPlanDetailsButton = true;
						this.actionButton = true;
                        this.parentawbitem = result.body.returnvalue.ParentAWbDetail;
                        this.parentawbitem_length = result.body.returnvalue.ParentAWbDetail.length;
                        if (this.parentawbitem.length > 0) {
                                const detail = this.parentawbitem[0];
                                this.showGenerateEBNButton =
                                    ['DispatchOutScan', 'OFD', 'INTransit'].includes(detail.shipmentstatus) &&
                                    detail.vehicle_id != null &&
                                    detail.is_handoverload === 'Yes' &&
                                    (!detail.ebn || detail.ebn === '');
                        }

                        if (
                        Array.isArray(this.parentawbitem) &&
                        this.parentawbitem.length > 0 &&
                        this.parentawbitem[0].parentawb
                        ) {
                        this.searchparentawb = this.parentawbitem[0].parentawb;
                        }
                    } else {
                        this.showPlanDetailsButton = false;
						this.actionButton = false;
                        this.parentawbitem = [];
                        this.OFDCount = {};
                        this.totalCount = {};
                        this.NDRCount = {};
                        this.DLVCount = {};
                        this.searchparentawb='';
                    }
                })
                .catch((ex) => {
                    console.log('error', ex)
                })
        },
        VehicleDetailsModalById(value) {
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/VehicleDetailsModalById`, { vehicle_id: value })
                .then(result => {
                    const vehicle = result.body && result.body.returnvalue && result.body.returnvalue[0];
                    if (vehicle && vehicle.vehicle_no) this.VehicleDetailsModal(vehicle.vehicle_no);
                });
        },

        VehicleDetailsModal(value){				
            console.log('vehicleno',value)
            const Obj = {
                vehicle_no: value
            };
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getVehicleDetailsForShipmentTracking`,Obj).then((result) => {
                if (result.body.returnmsg === 'Successful') {
                    this.vehicleData = result.body.returnvalue;
                    this.vehicleObj.vehiclename=this.vehicleData[0].vehicle_name;
                    this.vehicleObj.hub_title=this.vehicleData[0].hub_title;
                    this.vehicleObj.vehiclenotext=this.vehicleData[0].vehicle_no;
                    this.vehicleObj.registration_notext=this.vehicleData[0].registration_no;
                    this.vehicleObj.movement_typetext=this.vehicleData[0].movement_type;
                    this.vehicleObj.vehiclephysicalweighttext=this.vehicleData[0].vehiclephysicalweight;
                    this.vehicleObj.vehicledimensionsweighttext=this.vehicleData[0].vehicledimensionsweight;
                    this.vehicleObj.vehicleweightcarryingtext=this.vehicleData[0].vehicleweightcarrying;
                    this.vehicleObj.vehicle_fuel_typetext=this.vehicleData[0].vehicle_fuel_type;
                    this.vehicleObj.puc_urltext=this.vehicleData[0].puc_url;
                    this.vehicleObj.registration_urltext=this.vehicleData[0].registration_url;
                    this.vehicleObj.insurance_urltext=this.vehicleData[0].insurance_url;
                    this.vehicleObj.permit_urltext=this.vehicleData[0].permit_url;
                    this.vehicleObj.labour_chargestext=this.vehicleData[0].labour_charges;
                    this.vehicleObj.fixed_kmstext=this.vehicleData[0].fixed_kms;
                    this.vehicleObj.fixed_freightrate=this.vehicleData[0].fixed_freightrate;
                    this.vehicleObj.extra_kmratetext=this.vehicleData[0].extra_kmrate;
                    this.vehicleObj.workingdaystext=this.vehicleData[0].workingdays;
                    this.vehicleObj.paymenttypetext=this.vehicleData[0].paymenttype;
                    this.vehicleObj.driverfirstname=this.vehicleData[0].driverfirstname;
                    this.vehicleObj.driverlastname=this.vehicleData[0].driverlastname;
                    this.vehicleObj.drivermobilenumber=this.vehicleData[0].drivermobilenumber;
                    this.vehicleObj.driveraltmobilenumber=this.vehicleData[0].driveraltmobilenumber;
                    this.vehicleObj.driving_license=this.vehicleData[0].driving_license;
                    this.vehicleObj.helperfirstname=this.vehicleData[0].helperfirstname;
                    this.vehicleObj.helperlastname=this.vehicleData[0].helperlastname;
                    this.vehicleObj.helpermobilenumber=this.vehicleData[0].helpermobilenumber;
                    this.vehicleObj.helperaltmobilenumber=this.vehicleData[0].helperaltmobilenumber;
                    this.vehicleObj.transporter_vehicle_type=this.vehicleData[0].transporter_vehicle_type;
                    this.vehicleObj.transporter_company_name=this.vehicleData[0].transporter_company_name;
                    this.vehicleObj.transporter_mobilenumber=this.vehicleData[0].transporter_mobilenumber;
                    this.vehicleObj.transporter_emailid=this.vehicleData[0].transporter_emailid;
                    this.vehicleObj.transporter_gst_no=this.vehicleData[0].transporter_gst_no;
                    this.vehicleObj.t_bankaccountname=this.vehicleData[0].t_bankaccountname;
                    this.vehicleObj.t_bankname=this.vehicleData[0].t_bankname;
                    this.vehicleObj.t_branchname=this.vehicleData[0].t_branchname;
                    this.vehicleObj.t_accountnumber=this.vehicleData[0].t_accountnumber;
                    this.vehicleObj.t_ifsccode=this.vehicleData[0].t_ifsccode;
                    this.vehicleObj.t_address=this.vehicleData[0].t_address;
                    this.vehicleObj.t_city=this.vehicleData[0].t_city;
                    this.vehicleObj.t_state=this.vehicleData[0].t_state;
                    this.vehicleObj.t_pincode=this.vehicleData[0].t_pincode;
                    this.vehicleObj.t_aadhar=this.vehicleData[0].t_aadhar;
                    this.vehicleObj.t_bankcancelledcheque=this.vehicleData[0].t_bankcancelledcheque;
                    this.vehicleObj.t_gstincertificate=this.vehicleData[0].t_gstincertificate;
                    this.vehicleObj.t_pan=this.vehicleData[0].t_pan;
                    this.vehicleObj.t_vendortype=this.vehicleData[0].t_vendortype;
                    this.vehicleObj.transporter_name=this.vehicleData[0].transporter_name;
                    this.vehicleObj.vehicle_size=this.vehicleData[0].vehicle_size;
                    this.vehicleObj.isactive=this.vehicleData[0].isactive;
                    this.vehicleObj.manifested_vh_type=this.vehicleData[0].manifested_vh_type;
                    this.vehicleObj.main_vh_type=this.vehicleData[0].main_vh_type;
                    this.vehicleObj.vehicle_type=this.vehicleData[0].vehicle_type;
                    this.openVehicleDetails = true;
                    this.VehicleListingLog(this.vehicleData[0].vehicle_id)
                } else {

                }
            }).catch((er) => { })
		},

        trackinghistory: function (value) {
            this.isBusyhistory = true;
            const customerGetAllobj = {
                parentawb: value,
                is_asn: this.route_id == 'normal' ? 'NO' : 'YES',
            }

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/consignmentActivityTracking`, customerGetAllobj)
                .then((result) => {
                    this.isBusyhistory = false;
                    if (result.body.returnmsg === 'Successful') {
                        this.itemhistory = result.body.returnvalue;
                        for (let i = 0; i < this.itemhistory.length; i++) {
                            const element = this.itemhistory[i];
                            console.log(element.process);
                            if (element.process === 'Incident Reported') {
                                console.log(i);
                            }
                        }       
                        this.manualUpdate = result.body.returnvalue[0].manual_update;
                    } else {
                        this.itemhistory = [];
                    }
                })
                .catch((ex) => {
                    console.log('error', ex)
                })
        },

        status_logistic: function (value) {
            this.isBusy = true;
            const customerstatusobj = {
                shippingid: value,
            }
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getlogisticlogdetails`, customerstatusobj).then((result) => {
                    if (result.body.returnvalue.length > 0) {

                        this.logisticlogdata = result.body.returnvalue;
                        this.isGetlogisticlogdetails = 1
                        this.isBusy = false

                    } else {
                        this.logisticlogdata = []
                        this.isGetlogisticlogdetails = 1
                        this.isBusy = false


                    }
                })
                .catch((ex) => {
                    console.log('error', ex)
                })
        },

        status_custom: function (value) {
            this.isBusy = true;
            const customobj = {
                shippingid: value
            }

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/statusforcustom`, customobj).then((result) => {
                    if (result.body.returnvalue.length > 0) {

                        this.customlogdata = result.body.returnvalue;
                        this.isGetlogisticlogdetails = 1
                        this.isBusy = false
                        this.searchvaluesarr = []

                    } else {
                        this.customlogdata = []
                        this.isGetlogisticlogdetails = 1
                        this.isBusy = false;
                        this.searchvaluesarr = []
                    }
                })
                .catch((ex) => {
                    console.log('error', ex)
                })
        },

        viewDetails: function (value) {
            this.awbdetailsmodal = true;
            this.detailsitem = value;
        },

        detailsCancel: function () {
            this.awbdetailsmodal = false;
        },


        status_sms: function (value) {
            this.isBusy = true;
            const smsobj = {
                shippingid: value
            }

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/displaysmslog`, smsobj).then((result) => {
                    this.isBusy = false;
                    if (result.body.returnvalue.length > 0) {

                        this.smslogdata = result.body.returnvalue;
                        this.isGetlogisticlogdetails = 1;

                    } else {
                        this.smslogdata = []
                        this.isGetlogisticlogdetails = 1;

                    }
                })
                .catch((ex) => {
                    console.log('error', ex)
                })
        },

        osr_email_details: function (value) {
            this.isBusy = true;
            const osremailobj = {
                shippingid: value
            }
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getosremaildetails`, osremailobj).then((result) => {
                    this.isBusy = false;
                    if (result.body.returnvalue.length > 0) {

                        this.osremaildata = result.body.returnvalue;

                    } else {
                        this.osremaildata = [];

                    }
                })
                .catch((ex) => {
                    console.log('error', ex)
                })
        },

        babygearpushlog: function (value) {
            this.isBusy = true;
            const pushlogobj = {
                shippingid: value
            }
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getwarrantyshipmentbabygearpushlog`, pushlogobj).then((result) => {
                    this.response_msg = result.body.returnmsg;
                    if (result.body.returnmsg === 'Successful') {
                        ;
                        this.isBusy = false;

                    } else {
                        this.babygeardata = [];
                        this.response_msg = '';
                        this.isBusy = false;

                    }
                })
                .catch((ex) => {
                    console.log('error', ex)
                })
        },
            clear1:function(){
				this.form.selectaction = null
				this.remarktextbox = false
				this.ndrReason = false
				this.ndrReasonButton = false
				this.form.selectReason = null
				this.form.remarktext = '',
				this.othertextbox = false
				this.form.other = ''
				this.errors.clear('form-2')
			},
        clear: function () {
            this.customer = {}
            this.parentawbitem = [];
            this.parentawbitem_length = 0;
            this.OFDCount = {};
            this.totalCount = {};
            this.NDRCount = {};
            this.DLVCount = {};
            this.itemhistory = [];
            this.searchvaluesarr = []
            this.ConsignmentMasterGetdata = []
            this.customlogdata = []
            this.smslogdata = []
            this.osremaildata = []
            this.logisticlogdata = []
            this.data = []
            this.dlvstatus = []
            this.is_mark_ofd = 0;
            this.babygeardata = [];
            this.response_msg = '';
            this.mpscountitem = [];
            this.mpscountitem_length = 0;
            this.OFDmpsCount = {};
            this.totalmpsCount = {};
            this.NDRmpsCount = {};
            this.DLVmpsCount = {};
            this.manualUpdate = '';
            this.showPlanDetailsButton = false;
            this.actionButton = false;
            this.errors.clear('form-1');

            // var searchlisting = document.getElementById('searchlisting')
            // searchlisting.style.display = 'none'
            // var searchlisting2 = document.getElementById('searchlisting2')
            // searchlisting2.style.display = 'none'
        },

        Viewimagedetails: function (data) {
            this.selected_user_details = data;
        },

        tracking_mpscount: function (value) {
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            this.isBusy = true;
            const Getobj = {
                parentawb: value,
                is_asn: this.route_id == 'normal' ? 'NO' : 'YES',
            }
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getShipmentCountStatus`, Getobj)
                .then((result) => {
                    this.isBusy = false;
                    if (result.body.returnmsg === 'successful') {
                        this.mpscountitem = result.body.returnvalue.ShipmetCount;
                        this.mpscountitem_length = result.body.returnvalue.ShipmetCount.length;
                        this.totalmpsCount = result.body.returnvalue.ShipmetCount[0];
                        this.OFDmpsCount = result.body.returnvalue.ShipmetCount[1];
                        this.NDRmpsCount = result.body.returnvalue.ShipmetCount[2];
                        this.DLVmpsCount = result.body.returnvalue.ShipmetCount[3];
                    } else {
                        this.mpscountitem = [];
                        this.mpscountitem_length = 0;
                        this.OFDmpsCount = {};
                        this.totalmpsCount = {};
                        this.NDRmpsCount = {};
                        this.DLVmpsCount = {};
                    }
                })
                .catch((ex) => {
                    console.log('error', ex)
                })
        },

        extractCodes(lastcomments) {
            // Split the lastcomments by the phrases "Damage marked against" or "Defective marked against"
            let phrases = ['Damage marked against', 'Defective marked against'];
            let codes = '';
            phrases.forEach(phrase => {
                if (lastcomments.includes(phrase)) {
                codes = lastcomments.split(phrase)[1].trim();
                }
            });
            // Split the codes by commas to get an array of codes
            
            return codes.split(',');
        },

        showDamegeimage: function (data){
            this.loader=true;
            this.damageimg = true;
            this.damageMPSno = '';
            this.damageitem =[];
            this.damageMPSno = data;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const Obj = {
                mpsno: this.damageMPSno 
            }

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getDamagedBoxImage`,Obj).then(
            (result) =>{
                this.loader=false;
                if (result.body.returnmsg==='Successful') {
                    this.damageitem = result.body.returnvalue;
                } else {
                    this.damageitem =[];
                }
            })
            .catch((er)=>
            {})
        },

        showIncidentimage: function(data,type){
            this.imgdata=[];
            this.loader=true;
            this.incidentitem =[];
            this.type='';
            this.type = type;
            this.incidentimage = true;
            this.imgdata = data;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const Obj = {
                vehicleid: data.vehicle_id,
                index: data.index
            }

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getIncidentImageVideo`,Obj).then(
            (result) =>{
                this.loader=false;
                if (result.body.returnmsg==='Successful') {
                    this.incidentitem = result.body.returnvalue[0];
                } else {
                    this.incidentitem =[];
                }
            })
            .catch((er)=>
            {})
        },

        showIncidentvideo: function(data){
            this.incidentvideo = true;
        },
        downloadFile(fileUrl) {
        // Open the file URL in a new tab
			if (fileUrl) {
			window.open(fileUrl, '_blank');
			} else {
			this.$fire('No file available for download!', {
				title: 'Error',
				variant: 'danger',
				solid: true,
			});
			}
		},
        viewPlanDetails(){
				this.showPlanDetails=!this.showPlanDetails;
				this.viewPlanInShipmentTrackingList();
		},
        actionModal(){
            this.getNdrReasons();
            this.form.selectaction = null;
            this.form.remarktext = '';
            this.form.other = '';
            this.form.selectReason = null;
            this.ndrReasonButton = false;
            this.remarktextbox = false;
            this.ndrReason = false;
            this.othertextbox = false;
            this.showActionModal = true;
        },
        updateRemark(){
            this.loader = true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const obj = {
                parentawb: this.customer.parentawb,
                awb_remark: this.form.remarktext,
                createdby: userInfo.sysemailid
            };
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/markAWBReason`, obj).then(
            (result) => {
                this.loader = false;
                if (result.body.returnmsg === 'Successful') {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "success",
                        timer: 30000
                    });
                    this.showActionModal = false;
                    // this.remarktext = '';
                    this.tracking_main(this.customer.parentawb);
                    this.trackinghistory(this.customer.parentawb);
                    this.tracking_mpscount(this.customer.parentawb);
                }else{
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000
                        });
                }
            }).catch((er) => { })    
		},
        downloadDirectTaxillaEwayBill(item){
            // document.getElementById("overlay").style.display = "block";
            let doc_Obj={
            ebn:`${item.ebn}`,
            awb:`${item.parentawb}`
            }
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/downloadDirectEwayBillFromTaxilla`,doc_Obj).then((response)=>{
            // document.getElementById("overlay").style.display = "none";
            if(response.body.returnmsg =='Successful'){
            let url = response.body.returnvalue;
            window.open(url, '_blank');
            // this.dailyTrip(this.selected_status);
            }else{
            this.$fire({text:'Error In Download',type: "error",timer: 30000})
            }
                    
            }).catch(err=>{
            console.error('err------------------->',err);
            this.$fire({text:'Error In Download',type: "error",timer: 30000})
            document.getElementById("overlay").style.display = "none";
            })
        },
        viewPlanInShipmentTrackingList() {
            this.loader = true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            const Obj = {
                parentawb: this.customer.parentawb
            };
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/viewPlanInShipmentTracking`, Obj)
            .then((result) => {
                this.loader = false;
                if (result.body.returnmsg === 'Successful') {
                    const rawPlans = result.body.returnvalue;

                    // Check if oldPlans and newPlans exist and are not empty
                    if (Object.keys(rawPlans.oldPlans).length > 0 || Object.keys(rawPlans.newPlans).length > 0) {
                        this.allPlans = [
                            ...(rawPlans.oldPlans
                                ? Object.values(rawPlans.oldPlans).map(plans => ({
                                    date: (plans[0] && plans[0].planning_date) || "Unknown Date",
                                    items: plans || [],
                                }))
                                : []),

                            ...(rawPlans.newPlans
                                ? Object.values(rawPlans.newPlans).map(plans => ({
                                    date: (plans[0] && plans[0].planning_date) || "Unknown Date",
                                    items: plans || [],
                                }))
                                : []),
                        ];
                    } else {
                        this.allPlans = []; // Set empty array if both are empty
                    }

                } else {
                    this.allPlans = [];
                }
            }).catch((error) => {
                this.loader = false;
                console.error("Error fetching plans:", error);
                this.allPlans = []; // Set empty array in case of error
            });
		},
        generateTabTitle(planIndex, date) {
            return `Plan-${planIndex}: ${date}`;
        },
        async openMpsLogsModal(parentawb) {
            this.mpsdetails = []
            try {
            const response = await this.$http.post(
                `${CONSTANTS.MIGRATION_API_URL}/getMpsLogsByParentAwb`,
                { parentawb: parentawb }
            )
            if (response.body.returnmsg === "Successful") {
                this.mpsdetailsModal = true
                this.mpsdetails = response.body.returnvalue
            } else {
                this.mpsdetails = []
                this.$fire({
                text: response.body.returnvalue || "No log found",
                type: "error",
                timer: 5000
                })
            }
            } catch (err) {
               console.error(err)
                this.$fire({
                    text: "Error fetching hub users",
                    type: "error",
                    timer: 5000
                })
            }
        },
        async openActivityModal(parentawb) {
            this.actdetails = []
            try {
            const response = await this.$http.post(
                `${CONSTANTS.MIGRATION_API_URL}/getActivityLogsByParentAwb`,
                { parentawb: parentawb }
            )
            if (response.body.returnmsg === "Successful") {
                this.actdetailsModal = true
                this.actdetails = response.body.returnvalue
            } else {
                this.actdetails = []
                this.$fire({
                text: response.body.returnvalue || "No log found",
                type: "error",
                timer: 5000
                })
            }
            } catch (err) {
               console.error(err)
                this.$fire({
                    text: "Error fetching hub users",
                    type: "error",
                    timer: 5000
                })
            }
        },
    },

    filters: {
        datechange: function (value) {
            if (value == null) {
                return '-';
            } else {
                var d = new Date(value)
                var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
                var month = d.getMonth() + 1;
                var curr_year = d.getFullYear();
                var curr_month = month < 10 ? '0' + month : '' + month;
                var hours = d.getHours();
                var minutes = d.getMinutes();
                var ampm = hours >= 12 ? 'pm' : 'am';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var strTime = hours + ':' + minutes + ' ' + ampm;
                return curr_date + '-' + curr_month + '-' + curr_year + '  ' + " " + strTime;

            }
        }
    }
}; 
</script>

<style type="text/css">
  .b-table-caption-top{
    color: black;
  }
  .hyperlink {
		text-decoration: underline;
		color:dodgerblue;
		cursor: pointer;
	}
/* Use deep selector to target BootstrapVue tab titles */
  
  ::v-deep(.nav-tabs .nav-link) {
	background-color: #ddd !important;
  }
  
  ::v-deep(.nav-tabs .nav-link.active) {
	background-color: #bbb !important;
  }
  
  ::v-deep(.nav-tabs .nav-link:hover) {
	background-color: #ccc !important;
  }
  .ebn-link {
  text-decoration: underline;
  color: #007bff;
}

.download-icon {
  cursor: pointer;
  font-size: 20px;
  color: #007bff;
  margin-left: 8px;
}

.ebn-details {
  margin-top: 4px;
  font-size: 13px;
  color: #555;
}

.invoice-missing {
  display: block;
  color: red;
  font-weight: bold;
  margin-top: 2px;
}

.log-link {
  color: #007bff;
  cursor: pointer;
  font-weight: 500;
}

.log-link:hover {
  text-decoration: underline;
}
.hub-id-text {
  color: #007bff;   /* Blue color */
  font-weight: 600; /* Slightly bold */
}
.status-ofd {
  background-color: #ffe0b3 !important; /* Light Orange */
}

.status-intransit {
  background-color: #cce5ff !important; /* Light Blue */
}

.status-delivered {
  background-color: #d4edda !important; /* Light Green */
}

.status-ndr {
  background-color: #f8d7da !important; /* Light Red */
}
.full-modal .modal-dialog {
  max-width: 100%;
  width: 100%;
  height: 100%;
  margin: 0;
}

.full-modal .modal-content {
  height: 100%;
  border-radius: 0;
}
</style>
